<template>
    <div>
        <slot name="mainImg"></slot>
        <div id="div_tools" ref="div_tools" :data-clear-img-view="localState.debugFlags.clearImgView ? 'true' : 'false'"
            :data-tools-are-selectable="toolsAreSelectable ? 'true' : 'false'"
            style="left:0; top:0; position:absolute;">
            <svg id="svg_tools" ref="svg_tools"
                style="left:0px; top:0px; pointer-events:none; position:absolute; z-index:20; overflow:visible;">

                <defs>
                    <filter id="fDoubt" x="-250%" y="-250%" width="500%" height="500%">
                        <feComponentTransfer>
                            <feFuncR type="table" tableValues="0.85"></feFuncR>
                            <feFuncG type="table" tableValues="0.22"></feFuncG>
                            <feFuncB type="table" tableValues="1"></feFuncB>
                        </feComponentTransfer>
                        <feMorphology operator="dilate"
                            :radius="toolConfidence.fRadius / localState.workAreaZoom.scale" />
                        <feGaussianBlur result="out"
                            :stdDeviation="toolConfidence.fStdDev / localState.workAreaZoom.scale" />
                        <feBlend in="SourceGraphic" in2="out" mode="normal" />
                    </filter>
                    <filter id="fDivergent" x="-250%" y="-250%" width="500%" height="500%">
                        <feComponentTransfer>
                            <feFuncR type="table" tableValues="1"></feFuncR>
                            <feFuncG type="table" tableValues="0.22"></feFuncG>
                            <feFuncB type="table" tableValues="0.22"></feFuncB>
                        </feComponentTransfer>
                        <feMorphology operator="dilate"
                            :radius="toolConfidence.fRadius / localState.workAreaZoom.scale" />
                        <feGaussianBlur result="out"
                            :stdDeviation="toolConfidence.fStdDev / localState.workAreaZoom.scale" />
                        <feBlend in="SourceGraphic" in2="out" mode="normal" />
                    </filter>
                </defs>

                <!-- denteROICMP 
                    key="uei"
                    v-if="localState.active.dente != null"
                ></denteROICMP -->

                <g id="g_segmentationFix" v-if="segmentationFix.active" :data-loading="segmentationFix.processing">
                    <template v-if="segmentationFix.result.pending_confirmation">
                        <path id="path_segmentationFixResult"
                            :class="{ 'drawing-path--single': segmentationFix.result.path.length > 0 }"
                            ref="path_segmentationFixResult" :style="{
                                '--path-length': segmentationFix.result.path.length
                            }" :d="segmentationFix.result.path.d" />
                    </template>
                    <template v-else>
                        <path id="path_segmentationFix" @mouseenter="showSegmentationFixTrigger"
                            :class="{ 'drawing-path': segmentationFix.selection.path.length > 0 }"
                            ref="path_segmentationFix" :style="{
                                '--path-length': segmentationFix.selection.path.length
                            }" :d="segmentationFix.selection.path.d" />
                    </template>
                </g>

                <rect id="denticaoPreviewRect" v-if="localState.debugFlags.showDenticaoRect" v-bind="{
                    x: constants.denticaoRect.x,
                    y: constants.denticaoRect.y,
                    width: constants.denticaoRect.width,
                    height: constants.denticaoRect.height
                }" />

                <circle id="toolPushCircle"
                    v-if="[gConsts.mov.types.HANDLES_PUSH, gConsts.mov.types.HANDLES_DEL].includes(localState.mov.type)"
                    :style="{
                        stroke: localState.mov.type == gConsts.mov.types.HANDLES_PUSH ? 'blue' : 'red',
                        fill: localState.mov.type == gConsts.mov.types.HANDLES_PUSH ? 'blue' : 'red',
                    }" v-bind="{
                        cx: scaledMousePos.x,
                        cy: scaledMousePos.y,
                        r: gConsts.tool.metrics.HANDLES_PUSH_DIST / localState.workAreaZoom.scale
                    }" />

                <toolCMP v-for="tool in (GET_jobLoaded ? jobTools : [])" :key="tool.id" v-bind="{
                    ref: tool.id,
                    id: tool.id,
                    tool: tool,
                    isToolFocused: localState.focused.toolIds.has(tool.id),
                    isToolSelected: tool.id == localState.selected.tool?.id,
                    isToolDenteActive: tool.dente && (localState.active.dente?.label?.id == tool.dente || (canShowActiveToothRegion && localState.active.toothRegion.has(tool.dente))),
                    isToolLocationActive: canShowActiveLocations && localState.active.externalLocations.has(tool.label.id),
                    isToolLabelVisible: tool.label.id == localState.tool.visibleLabel,
                    isToolLocationVisible: localState.tool.visibleLocations.has(tool.dente) || localState.focused.dentes.has(tool.dente)
                        || (localState.focused.regioesAnatomicas.has(tool.label.id)),
                    isToolActive: localState.active.tool.item ? tool.id == localState.active.tool.item?.id : false,
                    isToolMoving: localState.active.tool.item ? localState.mov.active ? tool.id == localState.active.tool.item?.id : false : false,
                    'data-layer': tool.label.layer,
                    'data-label': tool.label.id,
                }"></toolCMP>

                <crossHairCMP
                    v-if="GET_togglesCrossHair && (localState.mouseLocation == gConsts.mov.mouseLocations.WORK_AREA)"
                    :mousePos="scaledMousePos"></crossHairCMP>

                <g id="g_internalLocationTools" v-if="localState.internalLocation.canDisplay"
                    :data-show-face-tools="localState.debugFlags.showFaceTools"
                    :data-show-portion-tools="localState.debugFlags.showPortionTools"
                    :data-show-other-internal-tools="localState.debugFlags.showOtherInternalTools">
                    <toolCMP v-for="tool in localState.internalLocation.tools" :key="tool.id" v-bind="{
                        ref: tool.id,
                        id: tool.id,
                        tool: tool,
                        'data-layer': tool.label.layer,
                        'data-label': tool.label.id,
                    }"></toolCMP>
                </g>

                <g id="g_probableToothTools" v-if="localState.probableTooth.canDisplay"
                    :data-show-tools="localState.debugFlags.showDenticaoRect">
                    <toolCMP v-for="tool in localState.probableTooth.tools" :key="tool.id" v-bind="{
                        ref: tool.id,
                        id: tool.id,
                        tool: tool,
                        'data-layer': tool.label.layer,
                        'data-label': tool.label.id,
                    }"></toolCMP>
                </g>
            </svg>
        </div>
    </div>
</template>

// =========================================================================================
// =========================================================================================

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import { MOLAR_TOOTH_NUMBERS, PERMANENTE_TOOTH_COUNT, toothUtils } from '@/features/tooth/lib/toothUtils';
import { nodes } from '@/globals/nodes';
import { gConsts } from '@/globals/gConsts';
import { utils } from '@/globals/utils';
import { imageUtils } from '@/lib/imageUtils';
import { mathUtils } from '@/lib/math';
import { anotacaoUtils } from '@/features/anotacoes/lib/AnotacaoUtils';
import { evtBus } from '@/main';
import profiler from '@/globals/Profiler';
import { InternalLocationsToolBuilder } from '@/features/tooth/lib/builders/InternalLocationsToolBuilder.js';

import { undoRedoHistory } from '@/globals/undoRedo';
import _ from 'lodash';
import { toothMixin } from '@/features/tooth/mixins/toothMixin';

import toolCMP from './tools/tool.vue';
import crossHairCMP from './crossHair.vue';
import { EspecificacaoBuilder } from '@/features/anotacoes/lib/builders/EspecificacaoBuilder.js';


// =========================================================================================

export default {
    name: 'medidorCMP',
    components: {
        toolCMP,
        crossHairCMP,
    },

    mixins: [toothMixin],

    // =========================================================================================

    data() {
        return {
            gConsts: gConsts,
            htmlElems: null,  // parentElem, workAreaZoom e workArea ... init no mounted()
            undoRedoHistory: undoRedoHistory,
            toolCMPs: {
                inner: {},
                outer: {}
            },
            counters: {
                mMoves: 0,
                toolSerial: 0,
            },
            timeouts: {
                spAnnots_endSearchCollapse: {
                    ID: -1,
                    timeout: 2000
                }
            },
            toolConfidence: {
                fRadius: 7,
                fStdDev: 5
            },
            localState: {
                active: {
                    dente: null,
                    externalLocations: new Set(),
                    internalLocations: {
                        faces: [],
                        portions: [],
                    },
                    location: {
                        especificacao: null,
                    },
                    toothRegion: new Set(),
                    closestTooth: null,
                    tool: {
                        item: null,
                        toolPt: -1,
                        toolOffset: {
                            x: 0,
                            y: 0
                        }
                    },
                    node: {
                        label: null,
                        layer: null,
                    }
                },
                selected: {
                    tool: null,
                },
                tool: {
                    visibleLabel: null,
                    visibleLocations: new Set(),
                },
                focused: {
                    toolIds: new Set(),
                    dentes: new Set(),
                    regioesAnatomicas: new Set(),
                },
                mouseLocation: gConsts.mov.mouseLocations.OTHER,
                focusLocation: gConsts.mov.focusLocations.WORK_AREA,
                mousePos: {
                    x: 0,
                    y: 0
                },
                mov: {
                    moved: false,
                    active: false,
                    dragging: false,
                    type: -1,
                    target: '',
                },
                workAreaZoom: {
                    scale: 1,
                    offset: {
                        x: 0,
                        y: 0,
                    },
                    currentFitScale: 1,
                    currentPanelOffset: 0,
                },
                internalLocation: {
                    tools: [],
                    canDisplay: false,
                },
                probableTooth: {
                    tools: [],
                    canDisplay: false,
                },
                debugFlags: {
                    showFaceTools: false,
                    showPortionTools: false,
                    showOtherInternalTools: false,
                    showDenticaoRect: false,
                    clearImgView: false,
                }
            },
            hoverTool: null,
            sdAnnot: null,
            nodeSearchInput: null,
            jobTools: [],
            constants: {
                mediaDente: {
                    width: 0,
                    height: 0,
                },
                denticaoRect: {
                    width: 0,
                    height: 0,
                    x: 0,
                    y: 0,
                },
                featureFlags: {
                    localizacoesAutomaticas: true,
                }
            },
            sidebarPanel: {
                width: 0,
                observer: null,
            },
            segmentationFix: {
                active: false,
                selection: {
                    dente: null,
                    pts: [],
                    mousePos: {
                        x: 0,
                        y: 0,
                    },
                    rect: {
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0,
                        angle: 0
                    },
                    path: {
                        length: 0,
                        d: '',
                    },
                },
                processing: false,
                result: {
                    dente: null,
                    pts: [],
                    path: {
                        length: 0,
                        d: '',
                    },
                    pending_confirmation: false,
                }
            }
        }
    },

    watch: {
        GET_jobTools(newJobTools, oldJobTools) {
            // Carrega lista inicial de tools do job
            if (this.jobTools.length == 0) {
                // cloneDeep para mutar as tools localmente.
                this.jobTools = _.cloneDeep(newJobTools);
                this.counters.toolSerial = this.jobTools.length;
                this.buildInternalLocationTools();
                this.buildDenticaoRect();
                this.setFocusLocation(gConsts.mov.focusLocations.WORK_AREA);
            }
        },
        GET_execModeVIEW(newExecModeVIEW, oldExecModeVIEW) {
            if (newExecModeVIEW != oldExecModeVIEW) {
                this.refreshSelectedAnnotationItem();
                this.refreshFocusedAnnotationItem();
            }
        },
        GET_activeToolbarButton(newActiveToolbarButton, oldActiveToolbarButton) {
            if (newActiveToolbarButton != gConsts.ui.toolbar.buttons.FIX_SEGMENTACAO_DENTE) {
                this.clearSegmentationFixSelection();
            }
        },
    },

    // =========================================================================================

    computed: {
        ...mapState([
        ]),

        // -----------------------------------------------------------------
        ...mapGetters([
            'GET_jobMetrics',
            'GET_toothRegionRect',
            'GET_togglesCrossHair',
            'GET_reportNodes',
            'GET_dentesNodes',
            // 'GET_waZoomOffset',
            'GET_jobLoaded',
            'GET_jobTools',
            'GET_activeElem',
            'GET_nodesArray',
            'GET_teethSegTools',
            'GET_teethSegTools_sorted',
            'GET_teethLETools',
            'GET_denteTools',
            'GET_locationTools',
            'GET_regioesAnatomicasTools',
            'GET_teethLETools_sorted',
            'GET_hasLocationLayer_teethLE',
            'GET_hasLocationLayer_teethSeg',
            'GET_elemsLoaded',
            // 'GET_waZoomScale',
            'GET_nodeSearchStr',
            'GET_execModeVIEW',
            'GET_activeToolbarButton',
        ]),

        scaledMousePos() {
            return {
                x: (this.localState.mousePos.x - this.localState.workAreaZoom.offset.x) / this.localState.workAreaZoom.scale,
                y: (this.localState.mousePos.y - this.localState.workAreaZoom.offset.y) / this.localState.workAreaZoom.scale
            }
        },

        activeLayerTools() {
            return this.jobTools.filter(tool => tool.label.layer == this.localState.active.node.layer);
        },

        activeLabelAnnotationType() {
            if (!this.localState.active.node.label)
                return null;
            return anotacaoUtils.getLabelAnnotationTypeById(this.localState.active.node.label);
        },

        especificacoesActiveLabel() {
            return anotacaoUtils.getEspecificacoesByLabelId(this.localState.active.node.label);
        },

        grupoEspecificacoesActiveLabel() {
            return anotacaoUtils.getEspecificacaoTipoGrupoByLabelId(this.localState.active.node.label);
        },

        isToothRegionEnabled() {
            return [
                gConsts.node.report.annotation.types.RTOOTH,
                gConsts.node.report.annotation.types.PROX_ANAT_RTOOTH,
                gConsts.node.report.annotation.types.ANAT_RTOOTH,
                gConsts.node.report.annotation.types.TOOTH,
            ].includes(this.activeLabelAnnotationType);
        },

        isExternalLocationsEnabled() {
            if (!this.activeLabelAnnotationType)
                return true;
            return [
                gConsts.node.report.annotation.types.PROX_ANAT_RTOOTH,
                gConsts.node.report.annotation.types.ANAT_ONLY,
                gConsts.node.report.annotation.types.ANAT_RTOOTH,
                gConsts.node.report.annotation.types.TOOTH,
                gConsts.node.report.annotation.types.RTOOTH,
            ].includes(this.activeLabelAnnotationType)
        },

        labelAnnotationPermissions() {
            const toothRegion = [
                gConsts.node.report.annotation.types.RTOOTH,
                gConsts.node.report.annotation.types.PROX_ANAT_RTOOTH,
                gConsts.node.report.annotation.types.ANAT_RTOOTH
            ].includes(this.activeLabelAnnotationType)
            const externalLocation = [
                gConsts.node.report.annotation.types.PROX_ANAT_RTOOTH,
                gConsts.node.report.annotation.types.ANAT_ONLY,
                gConsts.node.report.annotation.types.ANAT_RTOOTH]
                .includes(this.activeLabelAnnotationType)

            const internalLocation = true

            return {
                toothRegion,
                externalLocation,
                internalLocation: internalLocation
            }
        },

        canShowActiveToothRegion() {
            if (!this.localState.active.node.label)
                return true;
            if (this.labelAnnotationPermissions.toothRegion)
                return true;
            return false
        },

        canShowActiveLocations() {
            if (!this.localState.active.node.label)
                return true;
            if (this.labelAnnotationPermissions.externalLocation)
                return true;
            return false
        },

        activeNodeLabelItem() {
            return this.$store.state.setup.proj.nodes.get(this.localState.active.node.label)
        },

        hasAnyActiveDebugFlag() {
            return Object.values(this.localState.debugFlags).some(flag => flag);
        },

        toolsAreSelectable() {
            if ([gConsts.mov.types.WA_PAN, gConsts.mov.types.IMG_BC].includes(this.localState.mov.type))
                return false;
            return this.$store.state.ui.toolbar.toolType != gConsts.tool.attrib.types.NO_TOOL;
        },

        segmentationFixToolEnabled() {
            return this.GET_activeToolbarButton == gConsts.ui.toolbar.buttons.FIX_SEGMENTACAO_DENTE;
        },

        denteJobTools() {
            return this.jobTools.filter(tool => tool.label.layer == gConsts.layer.locations.TEETH_SEG)
        }
    },

    // =========================================================================================

    methods: {
        ...mapActions([
            'ACT_runtimeUpdate',
            'ACT_uiUpdate',
            'ACT_toolAdd',
            'ACT_toolUpdate',
            'ACT_toolAddPts',
            'ACT_toolDelete',
        ]),

        // -----------------------------------------------------------------

        waMousePos: function (evt) {
            var waMousePos, waScaledMousePos, waUnscaledMousePos,
                zoom = this.localState.workAreaZoom,
                waBBox = this.htmlElems.workArea.getBoundingClientRect();

            waMousePos = {
                x: (evt.clientX - waBBox.x),
                y: (evt.clientY - waBBox.y)
            }
            waScaledMousePos = {
                x: waMousePos.x - zoom.offset.x,
                y: waMousePos.y - zoom.offset.y
            }
            waUnscaledMousePos = {
                x: waScaledMousePos.x / zoom.scale,
                y: waScaledMousePos.y / zoom.scale
            }

            return {
                normal: waMousePos,
                scaled: waScaledMousePos,
                unscaled: waUnscaledMousePos
            }
        },

        isKeyValueAllowedForSearch(key) {
            // console.log('isKeyValueAllowedForSearch: ', key);
            return key.length == 1;
        },

        // -----------------------------------------------------------------

        keyboardEvents: function (evt) {
            var newState,
                newSearchStr = '',
                searchAction = '',
                nodeSearchStr = this.GET_nodeSearchStr,
                labelInc = 0,
                rt = this.$store.state.runtime,
                ui = this.$store.state.ui;

            //                movStep = 50, 
            //                delta = { x: 0, y: 0 };

            // Apenas processa eventos de teclado se tiver com foco no work area ou annotations.
            if (!this.GET_elemsLoaded) {
                return;
            }

            switch (evt.type) {
                case 'keydown':
                    this.localState.debugFlags.showFaceTools = evt.altKey && evt.shiftKey && evt.code == 'KeyF';
                    this.localState.debugFlags.showPortionTools = evt.altKey && evt.shiftKey && evt.code == 'KeyP';
                    this.localState.debugFlags.showDenticaoRect = evt.altKey && evt.shiftKey && evt.code == 'KeyD';
                    this.localState.debugFlags.showOtherInternalTools = evt.altKey && evt.shiftKey && evt.code == 'KeyL';
                    this.localState.debugFlags.clearImgView = evt.shiftKey && evt.code == 'KeyA';
                    // if (this.localState.focusLocation == gConsts.mov.focusLocations.SIDEBAR_PANELS_PESQUISA) {
                    //     switch (evt.key) {
                    //         case 'ArrowDown' :
                    //             evtBus.$emit('evt_pesquisaAnotacoes_action', 'cursorMove', { direction: 'next' });
                    //             return;
                    //         case 'ArrowUp' :
                    //             evtBus.$emit('evt_pesquisaAnotacoes_action', 'cursorMove', { direction: 'previous' });
                    //             return;
                    //         case 'Enter' :
                    //             evtBus.$emit('evt_pesquisaAnotacoes_action', 'cursorSelectTerm');
                    //             return;
                    //         case 'Escape' :
                    //             return;
                    //     }
                    // }
                    if (evt.ctrlKey && evt.code == 'KeyF') {
                        this.setFocusLocation(gConsts.mov.focusLocations.LABEL_SEARCH_POPUP);
                        evtBus.$emit('evt_labelSearchAction', 'medidor', { searchTerm: '' });
                        return;
                    }
                    if (!(evt.ctrlKey || evt.altKey || evt.metaKey || evt.shiftKey) && !utils.userIsFocusedOnInput(document)) {
                        if (evt.key == 'Escape') {
                            if (this.segmentationFixToolEnabled && this.segmentationFix.active) {
                                this.clearSegmentationFixSelection();
                            } else if (this.localState.focusLocation == gConsts.mov.focusLocations.POPUP_ANOTACAO) {
                                evtBus.$emit('evt_popupAnotacao_close');
                                return;
                            } else if (this.localState.focusLocation == gConsts.mov.focusLocations.LABEL_SEARCH_POPUP) {
                                evtBus.$emit('evt_labelSearchPopup_close');
                                return;
                            } else if ([gConsts.mov.focusLocations.SIDEBAR_PANELS_RELATORIO, gConsts.mov.focusLocations.SIDEBAR_PANELS_ANATOMIA].includes(this.localState.focusLocation)) {
                                evtBus.$emit('evt_sidebarPanel_collapse');
                                return;
                            }
                        }
                        if (this.isKeyValueAllowedForSearch(evt.key) && ![gConsts.mov.focusLocations.POPUP_ANOTACAO].includes(this.localState.focusLocation)) {
                            const source = this.localState.focusLocation == gConsts.mov.focusLocations.SIDEBAR_PANELS_RELATORIO ? 'relatorio' : 'medidor';
                            // this.localState.focusLocation = gConsts.mov.focusLocations.SIDEBAR_PANELS_PESQUISA;
                            if (source !== 'relatorio') {
                                this.setFocusLocation(gConsts.mov.focusLocations.LABEL_SEARCH_POPUP);
                            }
                            evtBus.$emit('evt_labelSearchAction', source, { searchTerm: evt.key });
                            break;
                        }
                    }

                    if (evt.ctrlKey) {
                        this.localState.mov.type = gConsts.mov.types.WA_PAN;
                    } else if (evt.shiftKey && !this.hasAnyActiveDebugFlag) {
                        this.localState.mov.type = gConsts.mov.types.IMG_BC;
                    }
                    this.updateWorkAreaMovType();

                    switch (evt.key) {
                        case 'ArrowLeft': this.denteNav(gConsts.ui.shortcuts.PREV); break;
                        case 'ArrowRight': this.denteNav(gConsts.ui.shortcuts.NEXT); break;

                        case 'Delete':
                            console.log('Delete: ', this.localState.focusLocation, this.localState.selected.tool);
                            // if (!utils.userIsFocusedOnInput(document)) {
                            evtBus.$emit('evt_toolAction', 'deleteTool');
                            // }
                            // this.ACT_toolDelete(); 
                            break;

                        // case 'p' :
                        //     if (!evt.repeat) {
                        //         this.ACT_uiUpdate({ toggles : { showToolHandles : true } });
                        //     } 
                        //     break;

                        // case 'm' : this.ACT_toolUpdate( { mark : true } ); break;

                        case 'z':
                        case 'y':
                            if (evt.ctrlKey && this.localState.focusLocation == gConsts.mov.focusLocations.WORK_AREA) {
                                switch (evt.key) {
                                    case 'z': undoRedoHistory.undo(); break;
                                    case 'y': undoRedoHistory.redo(); break;
                                }
                            }
                            break;

                        // case 'd' :
                        //     if (evt.altKey && this.localState.focusLocation == gConsts.mov.focusLocations.WORK_AREA) {
                        //         if (evt.key == 'd') {
                        //             this.ACT_uiUpdate({ toggles : { clearImgView : true } });

                        //             evt.stopPropagation();
                        //             evt.preventDefault();
                        //         }
                        //     }
                        //     break;

                        // case ' ' :
                        //     if ( (rt.active.tool                                      ) && 
                        //          (rt.mov.type != gConsts.mov.types.TOOL_CREATION) ) {
                        //         switch (rt.active.tool.state) {
                        //             case gConsts.tool.state.confidence.OK        : newState = gConsts.tool.state.confidence.DOUBT; break;

                        //             case gConsts.tool.state.confidence.DOUBT     :
                        //             case gConsts.tool.state.confidence.DIVERGENT : newState = gConsts.tool.state.confidence.OK;    break;
                        //         }
                        //         this.ACT_toolUpdate({ state : newState });
                        //         evt.stopPropagation();   
                        //         evt.preventDefault();
                        //     }
                        //     break;

                        // case '1' :
                        // case '2' :
                        // case '3' :
                        // case '4' :
                        // case '5' :
                        //     activeStep = parseInt(evt.key)-1;
                        //     this.ACT_runtimeUpdate({ active : { 
                        //         step  : activeStep,
                        //         layer : gConsts.step.layers[activeStep] 
                        //     });
                        //     break;
                    }
                    break;

                case 'keyup':
                    this.localState.debugFlags.showFaceTools = false;
                    this.localState.debugFlags.showPortionTools = false;
                    this.localState.debugFlags.showDenticaoRect = false;
                    this.localState.debugFlags.showOtherInternalTools = false;
                    this.localState.debugFlags.clearImgView = false;
                    if ([gConsts.mov.types.WA_PAN, gConsts.mov.types.IMG_BC].includes(this.localState.mov.type)) {
                        this.localState.mov.type = -1;
                        this.updateWorkAreaMovType();
                    }
                    // switch (evt.key) {
                    // case 'p' : 
                    //     this.ACT_uiUpdate({ toggles : { showToolHandles : false } });
                    //     break;

                    // case 'd' : 
                    //     if (ui.toggles.clearImgView && this.localState.focusLocation == gConsts.mov.focusLocations.WORK_AREA) { 
                    //         this.ACT_uiUpdate({ toggles : { clearImgView : false } });

                    //         evt.stopPropagation();
                    //         evt.preventDefault();
                    //     }
                    //     break;
                    // }
                    break;
            }

            //            evt.stopPropagation();
            //            evt.preventDefault();

        },

        // -----------------------------------------------------------------

        denteNav(inc) {
            if (this.localState.focusLocation != gConsts.mov.focusLocations.WORK_AREA) {
                return;
            }

            var adLabel, adLabelIndex, newAdLabel, index, newAdArray, layer,
                newAd = null,
                dentes = null,
                rt = this.$store.state.runtime;

            console.log('denteNav: ', inc, "toothNav: ", this.$store.state.setup.config.toothNav, "activeDente: ", this.localState.active.dente);

            if ((this.localState.active.dente != null) &&
                (this.$store.state.setup.config.toothNav == gConsts.dente.navTypes.FIXED)) {

                // Se existe uma camada de SEG de dentes de navegacao, ela tem prioridade
                if (this.GET_hasLocationLayer_teethSeg) {
                    dentes = this.GET_teethSegTools;

                    // Senão usamos a camada de LE de navegacao, se houver
                } else if (this.GET_hasLocationLayer_teethLE) {
                    dentes = this.GET_teethLETools;
                }

                console.log("- denteNav.dentes: ", dentes);

                if (dentes != null) {
                    adLabel = parseInt(this.localState.active.dente.label.text, 10);
                    adLabelIndex = gConsts.dente.scanOrder.indexOf(adLabel);

                    if (adLabel > 28) {
                        inc *= -1;
                    }

                    for (index = adLabelIndex + inc; ((index >= 0) && (index < gConsts.dente.scanOrder.length)); index += inc) {
                        newAdLabel = gConsts.dente.scanOrder[index];
                        newAdArray = dentes.filter(navTool => navTool.label.text == newAdLabel);
                        if (newAdArray.length > 0) {
                            newAd = newAdArray[0];
                            break;
                        }
                    }

                    console.log("- denteNav.newAd: ", newAd);

                    // só muda se o novo é valido ...
                    if (newAd != null) {
                        this.localState.active.dente = newAd;
                        this.ACT_runtimeUpdate({ active: { dente: newAd?.label?.id || null } });
                    }

                    if (!this.$store.state.setup.config.centerTooth) {
                        this.centerActiveDente();
                    }

                }
            }
        },

        // -----------------------------------------------------------------

        mouseEvents: function (evt) {
            var movType,
                payload = {},
                toolInfo = {
                    type: -1,
                    tool: null,
                    toolPt: -1
                },
                mouseLocation = this.getMouseLocation(evt),
                // rt = this.$store.state.runtime,
                ui = this.$store.state.ui;

            profiler.start('mouseEvents');

            if (evt.type == 'mousedown') {
                this.updateFocusLocation(evt);
            }

            // Se o evento do mouse estiver ocorrendo sobre a workArea
            if (mouseLocation == gConsts.mov.mouseLocations.WORK_AREA) {

                if (evt.type == 'mousedown') {
                    /* 
                    A criação normal de uma tool funciona na seguinte sequência:
                        MouseDown -> MouseMove -> MouseUp
                    Se existe um TOOL_CREATION ativa aqui logo após um mouseDown que acabou de acontecer, quer dizer que o 
                        usuario clicou, soltou e depois clicou novamente o mouse sem movimentar, ou seja, na mesma posição. 
                        MouseDown -> MouseUp -> MouseDown
                    O termino da criação fica adiado ateh o proximo mouseUp (se houver movimento) e portanto
                        cancelo o mouseDown corrente pois iniciaria a criação de outra tool. 
                    */
                    if (this.localState.mov.type == gConsts.mov.types.TOOL_CREATION) {
                        this.localState.mov.dragging = true;
                        // this.ACT_runtimeUpdate({ mov : { dragging : true } });
                        return;
                    }

                    // A tecla CTRL tem prioridade e permite o PAN da imagem com o mouse mesmo com uma tool selecionada
                    if (evt.ctrlKey) {
                        movType = gConsts.mov.types.WA_PAN;

                    } else if (evt.shiftKey && !this.hasAnyActiveDebugFlag) {
                        movType = gConsts.mov.types.IMG_BC;

                        if (evt.button == 2) {
                            this.ACT_uiUpdate({ workArea: { imgBC: { reset: true } } });
                        }
                    } else {

                        if (this.segmentationFixToolEnabled) {
                            switch (evt.button) {
                                case 0:
                                    movType = gConsts.mov.types.SEGMENTATION_FIX_CREATION;
                                    break;
                            }
                        } else if ((this.localState.active.tool.item) && (evt.button == 0)) {
                            // Se clicou sobre uma tool (handles, corpo ou label) com o botão normal do mouse

                            toolInfo.tool = this.localState.active.tool.item;
                            switch (this.localState.mov.target) {
                                case 'h':
                                    movType = gConsts.mov.types.HANDLE_DRAG;
                                    toolInfo.toolPt = this.localState.active.tool.toolPt;
                                    break;
                                case 'body': movType = gConsts.mov.types.TOOL_DRAG; break;
                                case 'label': movType = gConsts.mov.types.LABEL_DRAG; break;
                            }

                        } else {
                            switch (evt.button) {
                                case 0:
                                    // Se clicou sobre a imagem e temos uma tool selecionada, partimos para criacao desta tool
                                    if (ui.toolbar.toolType != gConsts.tool.attrib.types.NO_TOOL) {
                                        movType = gConsts.mov.types.TOOL_CREATION;
                                        toolInfo.type = ui.toolbar.toolType;

                                        // Se clicou sobre a imagem sem tool selecionada, temos que olhar qual funcao esta ativa
                                    } else {
                                        switch (ui.toolbar.button) {
                                            case gConsts.ui.toolbar.buttons.WA_PAN: movType = gConsts.mov.types.WA_PAN; break;
                                            case gConsts.ui.toolbar.buttons.IMG_BC: movType = gConsts.mov.types.IMG_BC; break;
                                        }
                                    }
                                    break;

                                case 1:
                                case 2:
                                    if (ui.toolbar.button == gConsts.ui.toolbar.buttons.IMG_BC) {
                                        this.ACT_uiUpdate({ workArea: { imgBC: { reset: true } } });
                                        break;
                                    }
                                    toolInfo.tool = this.localState.active.tool.item;
                                    switch (evt.button) {
                                        case 1: movType = gConsts.mov.types.HANDLES_DEL; break;
                                        case 2: movType = gConsts.mov.types.HANDLES_PUSH; break;
                                    }
                                    break;
                            }
                        }
                    }

                    // Se nao for mouseDown, apenas continuo o movimento ativo (se algum)
                } else {
                    movType = this.localState.mov.type;
                }

                //    profiler.enter('Code block', 'Medidor.mouseEvents', '[executeEvents]');
                // Execute mouse movement
                switch (evt.type) {
                    case 'dblclick':
                        if (movType != gConsts.mov.types.TOOL_CREATION && [gConsts.mov.focusLocations.WORK_AREA].includes(this.localState.focusLocation)) {
                            this.fitToWorkArea();
                        }
                        break;
                    case 'mousedown': payload = this.mouseDown(evt, movType, toolInfo); break;
                    case 'mouseup': payload = this.mouseUp(evt); break;
                    case 'mousemove':
                        payload = this.mouseMove(evt);  // pode ter [mov] e [active] dentro do payload 

                        break;
                }
                //                profiler.exit(); 
                // evt.stopPropagation();   
                evt.preventDefault();
            } else {
                // Caso o mouse não esteja no workarea garante que desativar o activeDente e as locations ativas
                this.localState.active.externalLocations.clear();
                this.clearActiveToothRegion();
                if (this.localState.active.dente) {
                    this.localState.active.dente = null;
                    this.$updateActiveDenteOnStore(null);
                }
            }

            // profiler.profileBlock('ACT', 'Medidor.mouseEvents', 'ACT_runtimeUpdate', () => {
            //     this.ACT_runtimeUpdate(payload);
            // }); 

            profiler.end();

            // if ( (this.GET_execModeVIEW                                       ) && 
            //      (this.localState.active.dente                        ) && 
            //      (this.localState.active.externalLocations.has(this.localState.active.dente?.label.id)) ) {
            //     evtBus.$emit(
            //         'evt_nodeSearchAction', 
            //         gConsts.node.search.actions.LOCATION_FILTER, '', 
            //         this.htmlElems.workArea);
            // }

            return;
        },

        // -----------------------------------------------------------------

        getSidePanelItemByTarget(target) {
            if (this.htmlElems.sidePanelsItems.length == 0) {
                this.htmlElems.sidePanelsItems = Array.from(document.querySelectorAll("div[data-compType='sidePanelsItem']"));
            }
            return this.htmlElems.sidePanelsItems.find(sp => sp.contains(target));
        },

        setFocusLocation(focusLocation) {
            if (focusLocation != this.localState.focusLocation) {
                console.log('focusLocation changed to: ', focusLocation);
                this.localState.focusLocation = focusLocation;
                evtBus.$emit('evt_medidor_focusLocationChanged', { focusLocation: focusLocation });
            }
        },

        updateFocusLocation(evt) {
            var focusLocation = this.htmlElems.workArea.contains(evt.target)
                ? gConsts.mov.focusLocations.WORK_AREA
                : gConsts.mov.focusLocations.OTHER;

            if (this.htmlElems.sidebarPanels.contains(evt.target)) {
                const activePanel = this.htmlElems.sidebarPanels.getAttribute('data-active-panel');
                if (activePanel == 'relatorio') {
                    focusLocation = gConsts.mov.focusLocations.SIDEBAR_PANELS_RELATORIO;
                } else if (activePanel == 'pesquisa') {
                    focusLocation = gConsts.mov.focusLocations.SIDEBAR_PANELS_PESQUISA;
                } else if (activePanel == 'anatomia') {
                    focusLocation = gConsts.mov.focusLocations.SIDEBAR_PANELS_ANATOMIA;
                }
            }

            if (document.querySelector('div[data-compType="popupAnotacao"]')?.contains(evt.target)) {
                focusLocation = gConsts.mov.focusLocations.POPUP_ANOTACAO;
            }

            const foundSidePanel = this.getSidePanelItemByTarget(evt.target);
            if (foundSidePanel) {
                const selectedSidePanelName = foundSidePanel.id.replace('div_', '');
                if (Object.values(gConsts.mov.focusLocations).includes(selectedSidePanelName)) {
                    focusLocation = selectedSidePanelName;
                }
            }

            if (focusLocation != this.localState.focusLocation) {
                console.log('focusLocation changed to: ', focusLocation);
                this.setFocusLocation(focusLocation);

                if (focusLocation == gConsts.mov.focusLocations.WORK_AREA) {
                    evtBus.$emit('evt_popupAnotacao_close');
                }
            }
        },

        getMouseLocation(evt) {
            var mouseLocation = this.htmlElems.workArea.contains(evt.target)
                ? gConsts.mov.mouseLocations.WORK_AREA
                : gConsts.mov.mouseLocations.OTHER;

            this.htmlElems.sidePanels.every(sp => {
                if (sp.contains(evt.target)) {
                    mouseLocation = gConsts.mov.mouseLocations.SIDE_PANELS;
                    return false;
                } else {
                    return true;
                }
            });

            if (mouseLocation != this.localState.mouseLocation) {
                // console.log('mouseLocation changed to: ', mouseLocation);
                this.localState.mouseLocation = mouseLocation;
            }

            return mouseLocation;
        },

        // -----------------------------------------------------------------

        mouseDown: function (evt, movType, toolInfo) {
            var startPos, pM, handled,
                payload = { mov: {} },
                pts = [],
                waMousePos = this.waMousePos(evt),
                rt = this.$store.state.runtime;

            switch (movType) {
                case gConsts.mov.types.SEGMENTATION_FIX_CREATION:
                    this.createSegmentationFixSelection(waMousePos.unscaled);
                    break;
                case gConsts.mov.types.TOOL_CREATION:
                    // TODO: Verificar se faz sentido criar tool sem label ativo. Por enquanto deixa bloqueado.
                    if (!this.localState.mov.active && this.localState.active.node.label) {
                        startPos = waMousePos.unscaled;

                        pts.push(startPos);
                        if (utils.numToolPts(toolInfo.type) != 1) {
                            pts.push({ x: startPos.x, y: startPos.y });
                            toolInfo.toolPt = 1;
                        } else {
                            toolInfo.toolPt = 0;
                        }

                        // profiler.profileBlock('Action', 'Medidor.mouseDown', 'ACT_toolAdd', () => {
                        //     this.ACT_toolAdd({
                        //         type : toolInfo.type,
                        //         pts  : pts,
                        //         locations: Array.from(this.localState.active.externalLocations),
                        //         qualifiers: []
                        //     })
                        // });
                        var activeExternalLocations = Array.from(this.localState.active.externalLocations);
                        var activeInternalLocations = this.localState.active.internalLocations;
                        var regionsLocations = Array.from(this.localState.active.toothRegion);
                        let activeDenteId = this.localState.active.dente?.label?.id
                        if (!activeDenteId && this.activeLabelAnnotationType == gConsts.node.report.annotation.types.TOOTH)
                            activeDenteId = regionsLocations.at(0)

                        const newTool = this.createNewTool({
                            attrib: {
                                type: toolInfo.type,
                            },
                            coords: {
                                pts: pts,
                            },
                            locations: {
                                external: activeExternalLocations,
                                regions: regionsLocations,
                                internal: activeInternalLocations
                            },
                            dente: activeDenteId
                        });
                        this.updateJobToolsOnStore('add', newTool);
                        this.setActiveTool(newTool, toolInfo.toolPt);
                    }
                    break;

                case gConsts.mov.types.TOOL_DRAG:
                case gConsts.mov.types.HANDLE_DRAG:
                    pM = this.$Victor.fromObject(waMousePos.unscaled);
                    handled = this.toolCMPs.inner[toolInfo.tool.id].mouseDown(evt, pM, toolInfo.toolPt);
                    break;

                case gConsts.mov.types.WA_PAN:
                    break;
            }

            // Tô retornando o default/ativo qdo nao eh creation, mas o ideal seria nao gerar evento ...
            //            console.log('mouseDown: dragging');

            this.localState.mov.active = true;
            this.localState.mov.dragging = true;
            this.localState.mov.type = movType;
            this.updateWorkAreaMovType();
            this.refreshPopupAnotacaoOpenerVisibility();

            payload.mov = {
                // tool     : toolInfo.tool, 
                // toolPt   : toolInfo.toolPt,   
                // type     : movType,
                // active   : true,
                // mousePos : waMousePos.normal
            }
            return payload;
        },

        // -----------------------------------------------------------------

        mouseMove: function (evt) {
            var scaledDelta, delta, pM,
                tool, isInObj, movType,
                moved = false,
                handled = false,
                waMousePos = this.waMousePos(evt),
                payload = { mov: {}, active: {} },
                // rt = this.$store.state.runtime,
                zoom = this.localState.workAreaZoom;

            pM = this.$Victor.fromObject(waMousePos.unscaled);

            if (this.localState.mov.active) {
                tool = this.localState.active.tool.item;
                if (tool != null && this.toolCMPs.inner[tool.id]?.mouseMove) {
                    //                    profiler.profileBlock('method', 'Medidor.mouseMove', 'toolCMPs.inner[].mouseMove', () => {
                    // console.log("Handling mouseMove for tool: ", tool.id, typeof this.toolCMPs.inner[tool.id]?.mouseMove);
                    handled = this.toolCMPs.inner[tool.id]?.mouseMove(evt, pM, this.localState.mov.type, this.localState.active.tool.toolPt);
                    //                    }); 
                }

                if (!handled) {
                    scaledDelta = {
                        x: (waMousePos.normal.x - this.localState.mousePos.x), // / zoom.scale,
                        y: (waMousePos.normal.y - this.localState.mousePos.y)  // / zoom.scale
                    };

                    delta = {
                        x: scaledDelta.x / zoom.scale,
                        y: scaledDelta.y / zoom.scale
                    };

                    //                    profiler.profileBlock('Action', 'Medidor.mouseMove', 'ACT_uiUpdate', () => {
                    switch (this.localState.mov.type) {
                        case gConsts.mov.types.TOOL_CREATION:
                        case gConsts.mov.types.HANDLE_DRAG:
                        case gConsts.mov.types.LABEL_DRAG:
                        case gConsts.mov.types.TOOL_DRAG:
                        case gConsts.mov.types.HANDLES_PUSH:
                        case gConsts.mov.types.HANDLES_DEL:
                            this.handleActiveToolMovement(delta);
                            // this.ACT_toolUpdate({ delta : delta }); 
                            break;

                        case gConsts.mov.types.WA_PAN: this.updateWorkAreaZoom({ delta: scaledDelta }); break;
                        // case gConsts.mov.types.WA_PAN : this.ACT_uiUpdate({ workArea : { zoom  : { delta : scaledDelta } } }); break;
                        case gConsts.mov.types.IMG_BC: this.ACT_uiUpdate({ workArea: { imgBC: { delta: scaledDelta } } }); break;
                    }
                    //                    }); 
                }

                moved = true;
            } else {
                //    profiler.profileBlock('Method', 'Medidor.mouseMove', 'isIn', () => {
                isInObj = this.isIn(evt);
                //    }); 

                // payload.mov['tool'  ] = isInObj.isInTool;
                this.setActiveTool(isInObj.isInTool, isInObj.targetIdx);
                // payload.mov['type'  ] = (isInObj.isInTool ? gConsts.mov.types.TOOL_HOVER : -1);
                this.localState.mov.type = (isInObj.isInTool ? gConsts.mov.types.TOOL_HOVER : this.localState.mov.type);
                this.updateWorkAreaMovType();
                // payload.mov['target'] = isInObj.target;         
                this.localState.mov.target = isInObj.target;
                // payload.mov['toolPt'] = isInObj.targetIdx;

                if (isInObj.isInTool && (isInObj.isInTool.id != this.localState.active.tool.item?.id)) {
                    //                    console.log('isInObj.isInTool: ' + isInObj.isInTool.label);
                }
            }
            //            profiler.profileBlock('Method', 'Medidor.mouseMove', 'updateActiveDente', () => {
            payload.active = this.updateActiveDente(evt);
            //            }); 

            this.localState.mov.moved = this.localState.mov.moved || moved
            // payload.mov['mousePos'] = waMousePos.normal
            this.localState.mousePos = waMousePos.normal;

            return payload;
        },

        // -----------------------------------------------------------------

        mouseUp: function (evt) {
            var numPts, pM, waMousePos, newState,
                isToolCreation, activeTool, toolPt,
                // rt   = this.$store.state.runtime,
                zoom = this.localState.workAreaZoom,
                handled = false,
                payload = { mov: {} },
                minSizeEnsured = false,
                totalToolPtsReached = false,
                isPathTool = false,
                isLastToolPoint = false;

            isToolCreation = (this.localState.mov.type == gConsts.mov.types.TOOL_CREATION);
            activeTool = this.localState.active.tool.item;

            if (this.localState.mov.active) {
                if (isToolCreation && activeTool) {
                    numPts = utils.numToolPts(activeTool.attrib.type);

                    toolPt = this.localState.active.tool.toolPt;
                    isPathTool = ([gConsts.tool.attrib.types.PATH, gConsts.tool.attrib.types.CURVA].includes(activeTool.attrib.type));
                    totalToolPtsReached = (numPts == activeTool.coords.pts.length);
                    isLastToolPoint = totalToolPtsReached || (isPathTool && (evt.button == 2));
                    console.log('isToolCreation.tool.coords.pts', activeTool.coords.pts);
                    minSizeEnsured = (numPts == 1) ||
                        (this.$Victor.fromObject(activeTool.coords.pts[toolPt]).distance(this.$Victor.fromObject(activeTool.coords.pts[toolPt - 1])) > (10 / zoom.scale))
                } else if (!isToolCreation) {
                    if (activeTool && !this.localState.mov.moved) {
                        waMousePos = this.waMousePos(evt);
                        pM = this.$Victor.fromObject(waMousePos.unscaled);
                        handled = this.toolCMPs.inner[activeTool.id].mouseUp(evt, pM);


                        // Clique do botao direito (sem movimento) serve para mudar o state da tool
                        if (evt.button == 2) {
                            switch (activeTool.state.confidence) {
                                case gConsts.tool.state.confidence.OK: newState = gConsts.tool.state.confidence.DOUBT; break;

                                case gConsts.tool.state.confidence.DOUBT:
                                case gConsts.tool.state.confidence.DIVERGENT: newState = gConsts.tool.state.confidence.OK; break;
                            }

                            activeTool.state.confidence = newState;
                            this.$updateJobToolsOnStore('update.state', activeTool);

                            // this.ACT_toolUpdate({ 
                            //     tool_id: tool.id, 
                            //     state : newState 
                            // })
                        }
                    }

                    if (evt.button == 0 && !this.localState.mov.moved) {
                        this.changeSelectedTool(activeTool);
                    }
                }

                if (!isToolCreation || (isLastToolPoint && (minSizeEnsured || isPathTool))) {
                    payload.mov = {
                        // tool   : null,
                        // toolPt : -1,
                        type: gConsts.mov.types.TOOL_HOVER,
                        active: false,
                        moved: false,
                        mousePos: {
                            x: 0,
                            y: 0
                        }
                    }

                    if (isToolCreation && activeTool && this.isReportAnnotationTool(activeTool)) {
                        this.changeSelectedTool(activeTool, true);
                    }

                    // Se estamos criando uma tool temos que mudar o label (se estiver configurado assim)
                    if (isToolCreation && this.$store.state.setup.config.labelJump) {
                        nodes.labelNav(1);
                    }
                } else if ((!totalToolPtsReached || isPathTool) && minSizeEnsured) {
                    evtBus.$emit('evt_toolAction', 'addPts', { tool_pt: this.localState.active.tool.toolPt });
                    // this.ACT_toolAddPts({tool_id: tool.id, tool_pt: this.localState.active.tool.toolPt});

                    payload.mov = {
                        toolPt: activeTool.coords.pts.length - 1,
                        moved: false,
                    }
                }
            }

            //            console.log('mouseUp: not dragging');
            // payload['dragging'] = false;

            if (payload.mov.active != undefined)
                this.localState.mov.active = payload.mov.active;
            if (payload.mov.moved != undefined)
                this.localState.mov.moved = payload.mov.moved;
            if (payload.mov.toolPt != undefined)
                this.localState.active.tool.toolPt = payload.mov.toolPt;
            this.applyActiveToolDragMovement(evt);
            if (payload.mov.type != undefined) {
                this.localState.mov.type = payload.mov.type;
                this.updateWorkAreaMovType();
            }
            this.localState.mov.dragging = false;

            this.refreshPopupAnotacaoOpenerVisibility();

            return {};
        },

        // -----------------------------------------------------------------

        isIn(evt) {
            var pM, waMousePos, isInDist, maxDist,
                tool_cmp, tool_svgElem, toolId, toolsUnderMouse,
                curr_isInObj,
                isInObj = { isInDist: -1, isInTool: null, target: '', targetIdx: -1 },
                minDist = Infinity,
                rt = this.$store.state.runtime,
                zoom = this.localState.workAreaZoom;

            maxDist = gConsts.tool.metrics.ISIN_MAX_DIST / zoom.scale;
            waMousePos = this.waMousePos(evt);
            pM = this.$Victor.fromObject(waMousePos.unscaled);

            const activeTool = this.localState.active.tool.item;

            //            profiler.profileBlock('Code block', 'Medidor.isIn', '[is over mov.tool]', () => {
            // primeiro checamos se existe uma rt.mov.tool e se o mouse continua esta sobre ela
            if (activeTool && (this.localState.mov.type == gConsts.mov.types.TOOL_HOVER)) {
                isInObj = this.isIn_tool(evt, activeTool);
                //                console.log(`active tool - isIn_tool: ${isInObj.isInTool ? isInObj.isInTool.label.id : 'false'}`);
                if (!isInObj.isInTool) {
                    isInObj = utils.isIn_nearToolPath(pM, activeTool, maxDist);
                    //                    console.log(`active tool - nearToolPath: ${isInObj.isInTool ? isInObj.isInTool.label.id : 'false'}`);
                }
            }
            //            }); 

            //            profiler.profileBlock('Code block', 'Medidor.isIn', '[is over any tool]', () => {
            // Se ainda não temos match, olhamos se existe algum fill debaixo debaixo do mouse
            if (!isInObj.isInTool) {
                isInObj = this.isIn_tool(evt);
                //                console.log(`any tool - isIn_tool: ${isInObj.isInTool ? isInObj.isInTool.label.id : 'none'}`);
            }
            //            }); 

            //            profiler.profileBlock('Code block', 'Medidor.isIn', '[find nearest tool]', () => {
            // se a tool que estava debaixo do mouse no ultimo move não estah mais
            if (!isInObj.isInTool) {
                // Iteramos as outras tools da activeLayer
                //                nearbyTools.forEach(tool => {                    
                this.activeLayerTools.forEach(tool => {
                    if ((activeTool == null) || (tool != activeTool)) {  // pulamos o rt.mov.tool se tiver (jah pesquisamos ele acima ...)
                        curr_isInObj = utils.isIn_nearToolPath(pM, tool, maxDist);

                        // E achamos a que estah mais perto do mouse
                        if ((curr_isInObj.isInDist != -1) && (curr_isInObj.isInDist < minDist)) {
                            minDist = curr_isInObj.isInDist;
                            isInObj = curr_isInObj;
                        }
                    }
                });
                // if (nearbyTools.length > 0) {
                //     console.log(`nearby tools - nearToolPath: ${isInObj.isInTool ? isInObj.isInTool.label.id : 'none'}`);
                // }
            }
            //            }); 

            return isInObj;
        },

        isReportAnnotationTool(tool) {
            if (!tool)
                return false;
            return [gConsts.tool.attrib.types.PONTO].includes(tool.attrib.type)
        },

        refreshActiveLocationUpdateEvent() {
            this.$nextTick(() => {
                evtBus.$emit('evt_medidor_activeLocations_updated', {
                    dentes: Array.from(this.localState.active.toothRegion),
                    regioesAnatomicas: this.labelAnnotationPermissions.externalLocation ? Array.from(this.localState.active.externalLocations) : [],
                    especificacao: this.localState.active.location.especificacao
                });
            })
        },

        updateActiveExternalLocations(evt) {
            if (this.segmentationFixToolEnabled)
                return;

            // console.time('updateActiveExternalLocations');
            try {
                if (!this.isExternalLocationsEnabled) {
                    this.localState.active.externalLocations.clear();
                    return;
                }

                // const locationsTools = this.GET_locationTools.filter(locationTool => !locationTool.label.id.startsWith('lb_dente'));
                const locationsTools = this.GET_regioesAnatomicasTools;
                const newExternalLocationsTools = utils.findLocations(document, evt, locationsTools);

                // this.localState.active.externalLocations.clear();
                // newExternalLocationsTools.forEach(locationTool => this.localState.active.externalLocations.add(locationTool.label.id));
                this.localState.active.externalLocations = new Set(newExternalLocationsTools.map(locationTool => locationTool.label.id));
            } finally {
                // console.timeEnd('updateActiveExternalLocations');
                this.updateActiveEspecificacao(evt);
                this.refreshActiveLocationUpdateEvent();
            }
        },

        updateActiveInternalLocations(evt) {
            if (!this.constants.featureFlags.localizacoesAutomaticas)
                return;
            if (this.segmentationFixToolEnabled)
                return;
            // console.time('updateActiveInternalLocations');
            try {
                if (!this.isToothRegionEnabled) {
                    // localizacoes sobre dente ativo
                    if (!this.localState.active.dente) {
                        this.localState.active.internalLocations = {
                            faces: [],
                            portions: []
                        }
                        return;
                    }

                    let newInternalLocations = utils.findInternalLocations(document, evt, this.localState.internalLocation.tools);

                    newInternalLocations = newInternalLocations.filter(locationTool => locationTool.dente == this.localState.active.dente?.label?.id);
                    this.localState.active.internalLocations = {
                        faces: Array.from(new Set(newInternalLocations.map(locationTool => locationTool.locations.internal.faces.list[0]).filter(face => face))),
                        portions: Array.from(new Set(newInternalLocations.map(locationTool => locationTool.locations.internal.portions.list[0]).filter(portion => portion)))
                    }
                    // console.log(`activeInternalLocations updated : ${Array.from(internalLocationsMap.keys()).join(', ')}`);

                } else {
                    if (this.localState.active.toothRegion.size == 0) {
                        this.localState.active.internalLocations = {
                            faces: [],
                            portions: []
                        }
                        return
                    }

                    // localizacoes sobre regiao de dentes
                    var pM, waMousePos,
                        maxDist = this.GET_toothRegionRect.width;

                    waMousePos = this.waMousePos(evt);
                    pM = this.$Victor.fromObject(waMousePos.unscaled);

                    let closeToothInternalLocations = this.localState.internalLocation.tools
                        .filter(tool => this.localState.active.toothRegion.has(tool.dente))
                        .map(tool => {
                            const isInObj = utils.isIn_nearToolPath(pM, tool, maxDist);
                            return {
                                tool,
                                isInObj
                            }
                        }).filter(location => ['body', 'h'].includes(location.isInObj.target));

                    if (closeToothInternalLocations.length == 0) {
                        this.localState.active.internalLocations = {
                            faces: [],
                            portions: []
                        }
                        return
                    }

                    // Considera apenas as localizacoes mais proxima e em comum entre o maximo de dentes da regiao
                    // Agrupo entre as mesma localizacoes e deixo apenas a media das distancias
                    let closestLocations = { faces: [], portions: [] };

                    for (const locationType in closestLocations) {
                        // Se tiver mais de um dente, faz sentido considerar as faces? Tem como estar na regiao mesial de 2 dentes?
                        // Ainda mais que a regiao de dentes é filtrada para ser apenas sobre a mesma arcada/posicao
                        if (locationType == 'faces' && this.localState.active.toothRegion.size > 1) {
                            continue;
                        }
                        closestLocations[locationType] = closeToothInternalLocations
                            .reduce((acc, location) => {
                                const regionType = location.tool.locations.internal[locationType]?.list?.[0];
                                if (!regionType)
                                    return acc;
                                const currentLocation = acc.find(l => l.regionType == regionType);
                                if (currentLocation) {
                                    currentLocation.distanceList.push(location.isInObj.isInDist);
                                } else {
                                    acc.push({
                                        regionType,
                                        distanceList: [location.isInObj.isInDist]
                                    });
                                }
                                return acc;
                            }, []);

                        closestLocations[locationType] = closestLocations[locationType]
                            .filter(location => location.distanceList.length == Math.max(...closestLocations[locationType].map(l => l.distanceList.length)))
                            .map(location => ({
                                regionType: location.regionType,
                                meanDistance: location.distanceList.reduce((acc, curr) => acc + curr, 0) / location.distanceList.length
                            }))
                            .sort((a, b) => a.meanDistance - b.meanDistance)
                            .map(location => location.regionType);

                        if (locationType == 'portions' && closestLocations[locationType].length > 1) {
                            closestLocations[locationType] = closestLocations[locationType].filter(regionType => !['dente_completo__raiz'].includes(regionType));
                        }
                    }

                    this.localState.active.internalLocations = {
                        faces: closestLocations.faces.slice(0, 1),
                        portions: closestLocations.portions.slice(0, 1)
                    }

                }

                return;
            } finally {
                evtBus.$emit('evt_medidor_activeInternalLocations_updated', { locations: this.localState.active.internalLocations });
                // console.timeEnd('updateActiveInternalLocations');
            }

            // console.log("activeInternalLocations: ", JSON.stringify(this.localState.active.internalLocations));
        },

        clearActiveToothRegion() {
            this.localState.active.toothRegion = new Set();
            this.localState.active.closestTooth = null;
            this.refreshActiveLocationUpdateEvent();
        },

        getActiveEspecificacao(evt) {
            if (!this.constants.featureFlags.localizacoesAutomaticas) {
                return null;
            }

            const waMousePos = this.waMousePos(evt);
            const posicaoMouseWorkArea = waMousePos.unscaled
            const posicaoMouseClient = { x: evt.clientX, y: evt.clientY }

            const activeExternalLocationsList = Array.from(this.localState.active.externalLocations);
            const activeInternalLocations = this.localState.active.internalLocations;
            const activeToothRegionList = Array.from(this.localState.active.toothRegion);

            const especificacaoBuilder = new EspecificacaoBuilder(
                this.grupoEspecificacoesActiveLabel,
                activeExternalLocationsList,
                activeInternalLocations,
                activeToothRegionList,
                this.localState.active.closestTooth?.label?.id,
                this.localState.active.dente?.label?.id,
                this.denteJobTools,
                this.localState.probableTooth.tools,
                this.constants.mediaDente
            )

            const locatedOnMandibula = activeExternalLocationsList
                .some(regiao => ['lb_rRegAntMand', 'lb_rCorpoDirMand', 'lb_rCorpoEsqMand'].includes(regiao));
            const locatedOnMaxila = activeExternalLocationsList
                .some(regiao => ['lb_rRegAntMax', 'lb_rRegPostDirMaxila', 'lb_rRegPostEsqMaxila', 'lb_rSeioMaxDir', 'lb_rSeioMaxEsq'].includes(regiao));

            const especificacaoRegiaoPalatina = this.especificacoesActiveLabel.find(e => e.endsWith('regiao_palatina'))
            if (especificacaoRegiaoPalatina && locatedOnMaxila) {
                return especificacaoRegiaoPalatina;
            }

            // Se os dentes ativos da regiao nao existir na lista original, significa que sao os provaveis
            // const especificacaoProvavelRegiaoDente = this.especificacoesActiveLabel.find(e => e.endsWith('provavel_regiao_dente'))
            // if (especificacaoProvavelRegiaoDente &&
            //     activeToothRegionList.every(toothLabelId => !this.denteJobTools.some(tool => tool.label.id == toothLabelId))) {
            //     return especificacaoProvavelRegiaoDente;
            // }

            const especificacaoLocalizadoRaizDente = this.especificacoesActiveLabel.find(e =>
                e.endsWith('localizado_raiz_dente') ||
                e.endsWith('localizado_provavel_raiz_dente')
            );
            if (especificacaoLocalizadoRaizDente) {
                const result = especificacaoBuilder.buildLocalizadoRaizDente(posicaoMouseWorkArea, posicaoMouseClient)
                if (result) {
                    this.localState.active.toothRegion = new Set(result.referenceToothIds)
                    return result.especificacao;
                }
            }

            const especificacaoRegiaoDente = this.especificacoesActiveLabel.find(e => e.endsWith('regiao_dente'));
            if (especificacaoRegiaoDente) {
                const result = especificacaoBuilder.buildRegiaoDente(posicaoMouseWorkArea, posicaoMouseClient)
                if (result) {
                    this.localState.active.toothRegion = new Set(result.referenceToothIds)
                    return result.especificacao;
                }
            }

            const especificacaoAcimaDente = this.especificacoesActiveLabel.find(e => e.endsWith('acima_dente'));
            if (especificacaoAcimaDente) {
                const result = especificacaoBuilder.buildLocalizadoAcimaDente(posicaoMouseWorkArea)
                if (result) {
                    this.localState.active.toothRegion = new Set(result.referenceToothIds)
                    return result.especificacao;
                }
            }

            const especificacaoAbaixoDente = this.especificacoesActiveLabel.find(e => e.endsWith('abaixo_dente'));
            if (especificacaoAbaixoDente) {
                const result = especificacaoBuilder.buildLocalizadoAbaixoDente(posicaoMouseWorkArea)
                if (result) {
                    this.localState.active.toothRegion = new Set(result.referenceToothIds)
                    return result.especificacao;
                }
            }

            const especificacaoEntreRaizesDoDente = this.especificacoesActiveLabel.find(e => e.endsWith('entre_raizes_dente'));
            if (especificacaoEntreRaizesDoDente) {
                const result = especificacaoBuilder.builLocalizadoEntreRaizesDoDente(posicaoMouseWorkArea)
                if (result) {
                    this.localState.active.toothRegion = new Set(result.referenceToothIds)
                    return result.especificacao;
                }
            }

            const especificacaoEntreDentes = this.especificacoesActiveLabel.find(e => e.endsWith('entre_dentes'));
            if (especificacaoEntreDentes) {
                const result = especificacaoBuilder.buildLocalizadoEntreDentes(posicaoMouseWorkArea)
                if (result) {
                    this.localState.active.toothRegion = new Set(result.referenceToothIds)
                    return result.especificacao;
                }
            }

            const especificacaoProximoApiceDente = this.especificacoesActiveLabel.find(e => e.endsWith('proximo_apice_dente'))
            if (especificacaoProximoApiceDente) {
                const result = especificacaoBuilder.buildProximoApiceDente(posicaoMouseWorkArea)
                if (result) {
                    this.localState.active.toothRegion = new Set(result.referenceToothIds)
                    return result.especificacao;
                }
            }

            const especificacaoDistalDente = this.especificacoesActiveLabel.find(e => e.endsWith('distal_dente'));
            if (especificacaoDistalDente) {
                const result = especificacaoBuilder.buildLocalizadoDistalDente(posicaoMouseWorkArea)
                if (result) {
                    this.localState.active.toothRegion = new Set(result.referenceToothIds)
                    return result.especificacao;
                }
            }

            const especificacaoProximoDente = this.especificacoesActiveLabel.find(e => e.endsWith('proximo_dente'));
            if (especificacaoProximoDente) {
                return especificacaoProximoDente;
            }

            return null;
        },

        updateActiveEspecificacao(evt) {
            if (this.segmentationFixToolEnabled)
                return;

            const activeEspecificacao = this.getActiveEspecificacao(evt);
            // console.log('activeEspecificacao', activeEspecificacao, Array.from(this.localState.active.toothRegion).join(', '))

            this.localState.active.location.especificacao = activeEspecificacao;
            return activeEspecificacao;
        },

        updateActiveToothRegionLocations(evt) {
            try {
                if (!this.isToothRegionEnabled) {
                    this.clearActiveToothRegion();
                    return;
                }

                if (this.activeLabelAnnotationType == gConsts.node.report.annotation.types.TOOTH) {
                    this.localState.active.toothRegion = new Set(this.localState.active.dente ? [this.localState.active.dente.label.id] : []);
                    return;
                }

                // console.time('updateActiveToothRegionLocations');
                var maxDist, waMousePos;

                maxDist = this.GET_toothRegionRect.width;
                waMousePos = this.waMousePos(evt);

                let closeDentes = utils.findCloseDenteToolsFromPosition(this.denteJobTools, waMousePos.unscaled, maxDist);
                let probableDentes = [];

                if (this.constants.featureFlags.localizacoesAutomaticas) {
                    // Procuro dentes em um maior range
                    if (!closeDentes.length && !this.localState.active.dente && this.especificacoesActiveLabel.some(e => e.endsWith('proximo_dente'))) {
                        closeDentes = utils.findCloseDenteToolsFromPosition(this.denteJobTools, waMousePos.unscaled, maxDist * 2);
                    }

                    // Procuro dentes provaveis com dentes criados manualmente
                    if (!closeDentes.length && !this.localState.active.dente &&
                        this.especificacoesActiveLabel.some(e => e.endsWith('provavel_regiao_dente')) &&
                        this.localState.probableTooth.tools.length > 0) {
                        // Filtro os dentes existentes para nao dar conflito
                        const dentesProvaveisAusentes = this.localState.probableTooth.tools.filter(tool => !this.denteJobTools.some(dente => dente.label.id == tool.label.id));
                        probableDentes = utils.findCloseDenteToolsFromPosition(dentesProvaveisAusentes, waMousePos.unscaled, maxDist);
                        // console.log('probableDentes', probableDentes)
                    }
                }

                // console.log("closeDentes: ", closeDentes.map(dente => `${dente.tool.label.id} - ${dente.isInObj.isInDist}`).join('\n'));

                const toothRegionTools = [
                    ...closeDentes,
                    ...probableDentes,
                    this.localState.active.dente
                ].filter(tool => tool)

                // this.localState.active.toothRegion.clear();
                // toothRegionTools.filter(tool => tool).forEach(tool => this.localState.active.toothRegion.add(tool.label.id));
                this.localState.active.toothRegion = new Set(toothRegionTools.map(tool => tool.label.id));

                if (closeDentes.length == 0) {
                    this.localState.active.closestTooth = utils.findClosestToolByPosition(this.denteJobTools, waMousePos.unscaled)?.tool || null;
                    // console.log('this.localState.active.closestTooth', this.localState.active.closestTooth?.label?.id)
                } else {
                    this.localState.active.closestTooth = closeDentes.at(0);
                }
            } finally {
                this.updateActiveEspecificacao(evt);
                this.refreshActiveLocationUpdateEvent();
            }

            // console.timeEnd('updateActiveToothRegionLocations');
            // console.log("updateRegionsDentesLocations: ", Array.from(this.localState.active.toothRegion));
        },

        // -----------------------------------------------------------------

        isIn_tool(evt, tool) {
            return utils.isIn_tool(document, evt, this.activeLayerTools, tool);
        },

        // -----------------------------------------------------------------

        //         updateLocationInfo(evt) {
        //             var duration, 
        //                 update = false,
        //                 start = Date.now(),
        //                 rt = this.$store.state.runtime;

        //             /* Não procuro nem atualizo a [locationInfo] se:
        //                 - Não for mouseMove
        //                 - Estiver com o altKey ativado (lock da location corrente)
        //                 - Estiver em TOOL_CREATION, HANDLE_DRAG, HANDLES_PUSH, HANDLES_DEL ou LABEL_DRAG */
        //             if (evt.type == 'mousemove') {
        //                 if ( (evt.altKey                                                           ) ||
        //                     ([gConsts.mov.types.TOOL_CREATION,
        //                     gConsts.mov.types.HANDLE_DRAG  , 
        //                     gConsts.mov.types.HANDLES_PUSH ,
        //                     gConsts.mov.types.HANDLES_DEL  ,
        //                     gConsts.mov.types.LABEL_DRAG    ].includes(rt.mov.type)) ) {
        //                     return false;

        //                 } else {
        //                     // Se estiver hovering alguma tool, a [locationInfo] dela passe a ser a [activeLocationInfo]
        //                     if ( (rt.mov.tool                                ) && 
        //                          (rt.mov.type == gConsts.mov.types.TOOL_HOVER) ) {
        //                         newAd = utils.findDenteByLabel(this.GET_denteTools, rt.mov.tool?.dente);

        //                     // Nos outros casos, fazemos a localização do mouse baseado no tipo de location esperado apra o label corrente
        //                     } else {
        //                         newLocation = utils.findLocation(document, evt, this.GET_locationTools);

        //                         // Se estiver movendo uma tool, só atualiza se activeDente != null
        //                         if (rt.mov.type == gConsts.mov.types.TOOL_DRAG) {
        //                             newAd = newAd ? newAd : rt.active.dente;
        //                         } // Senão atualiza independente
        //                     }
        //                 }

        //                 if (newAd != rt.active.dente) {
        //                     this.ACT_runtimeUpdate({ active : { dente : newAd } });
        //                     updated = true;

        //                     if (this.GET_execModeView && newAd && this.locationLabels.has(newAd.label)) {
        //                         evtBus.$emit('evt_nodeSearchAction', gConsts.node.search.actions.LOCATION_FILTER, '', this.htmlElems.workArea);
        //                     }
        //                 }
        //             }

        //             duration = Date.now() - start;
        // //            console.log('updateActiveDente[2] duration (ms): ' + duration);

        //             return updated;
        //         },

        //         // -----------------------------------------------------------------


        updateActiveDente(evt) {
            var newAd,
                payload = {};
            // rt = this.$store.state.runtime;

            /* Não procuro nem atualizo o activeDente se:
                - Não for mouseMove
                - Estiver com o altKey ativado (lock do dente corrente)
                - Estiver em TOOL_CREATION, HANDLE_DRAG, HANDLES_PUSH, HANDLES_DEL ou LABEL_DRAG */
            if (evt.type == 'mousemove') {
                if ((evt.altKey) ||
                    ([gConsts.mov.types.TOOL_CREATION,
                    gConsts.mov.types.HANDLES_PUSH,
                    gConsts.mov.types.HANDLES_DEL,
                    gConsts.mov.types.LABEL_DRAG].includes(this.localState.mov.type))) {
                    return payload;

                } else {
                    // Se estiver hovering alguma tool, o dente dela passa a ser o activeDente
                    if ((this.localState.active.tool.item) &&
                        (this.localState.mov.type == gConsts.mov.types.TOOL_HOVER) &&
                        (this.localState.active.tool.item?.dente != null)) {
                        //                      profiler.profileBlock('Method', 'Medidor.updateActiveDente', 'findToolByLabelId', () => {
                        newAd = utils.findToolByLabelId(this.denteJobTools, this.localState.active.tool.item?.dente);
                        //                      });

                        // Nos outros casos, procura um dente debaixo do mouse
                    } else {
                        //                        profiler.profileBlock('Code block', 'Medidor.updateActiveDente', '[findDente/findLocations]', () => {
                        newAd = utils.findDente(document, { x: evt.clientX, y: evt.clientY }, this.denteJobTools, this.localState.active.dente);
                        this.updateActiveExternalLocations(evt);
                        this.$updateActiveToothRegionLocations(evt);
                        this.updateActiveInternalLocations(evt);
                        //                        });

                        // Se estiver movendo uma tool, só atualiza se activeDente != null
                        const isMovingTool = this.localState.mov.type == gConsts.mov.types.TOOL_DRAG ||
                            (this.localState.mov.type == gConsts.mov.types.HANDLE_DRAG && this.localState.active.tool.item?.attrib.type == gConsts.tool.attrib.types.PONTO);
                        if (isMovingTool) {
                            newAd = newAd ? newAd : this.localState.active.dente;
                        } // Senão atualiza independente
                    }
                }

                // Se o mouse não está no work area, garante que não tenha dente ativo configurado
                if (this.localState.mouseLocation != gConsts.mov.mouseLocations.WORK_AREA) {
                    newAd = null;
                }

                if (newAd?.label?.id != this.localState.active.dente?.label?.id) {
                    // payload.dente = newAd;
                    this.localState.active.dente = newAd;
                    evtBus.$emit('evt_medidor_activeDente_updated', newAd?.label?.id || null);
                    this.$updateActiveDenteOnStore(newAd?.label?.id || null);
                    // console.log(`activeDente updated : ${newAd ? newAd.label.id : 'none'}`);
                }
            }

            return payload;
        },

        // -----------------------------------------------------------------

        centerActiveDente() {
            var waCliRect, waCenter, adEl, adElCliRect, adCenter, delta,
                rt = this.$store.state.runtime,
                zoom = this.localState.workAreaZoom;

            if (!this.localState.active.dente) {
                return;
            }

            adEl = utils.findToolCMP(this.$root, this.localState.active.dente?.id).$el.childNodes[0];
            adElCliRect = adEl.getBoundingClientRect();
            adCenter = {
                x: adElCliRect.left + (adElCliRect.width / 2),  // * zoom.scale,
                y: adElCliRect.top + (adElCliRect.height / 2)   // * zoom.scale,
            }
            waCliRect = this.htmlElems.workArea.getBoundingClientRect();
            waCenter = {
                x: waCliRect.left + (waCliRect.width / 2),
                y: waCliRect.top + (waCliRect.height / 2)
            }
            delta = {
                x: Math.trunc(waCenter.x - adCenter.x),
                y: Math.trunc(waCenter.y - adCenter.y)
            }
            this.updateWorkAreaZoom({ delta: delta });
            // this.ACT_uiUpdate({ workArea : { zoom : { delta : delta } } });
        },

        // -----------------------------------------------------------------

        zoom: function (evt) {
            // var rt = this.$store.state.runtime;

            if (this.localState.mouseLocation != gConsts.mov.mouseLocations.WORK_AREA) { return; }

            var zFactor, delta, newScale,
                zoom = this.localState.workAreaZoom,
                waMousePos = this.waMousePos(evt);

            // vou aumentar/diminuir o zoom de um fator de 0.25 pra cada passo do mouseWheel
            zFactor = 1 + (Math.abs(evt.deltaY) / 400);  // zoomIn
            if (evt.deltaY > 0) {  // zoomOut
                zFactor = 1 / zFactor;
            }

            newScale = zoom.scale * zFactor;  // calcula o novo scale

            // Limita o zoomIn e zoomOut máximos
            if ((newScale > gConsts.ui.workArea.zoom.MIN) && (newScale < gConsts.ui.workArea.zoom.MAX)) {
                delta = {
                    x: (waMousePos.normal.x - (waMousePos.scaled.x * zFactor)) - zoom.offset.x,
                    y: (waMousePos.normal.y - (waMousePos.scaled.y * zFactor)) - zoom.offset.y
                }

                this.updateWorkAreaZoom({ scale: newScale, delta: delta });
                // this.ACT_uiUpdate({ workArea : { zoom : { 
                //     scale : newScale,
                //     delta : delta 
                // } } });            
            }

            evt.stopPropagation();
            evt.preventDefault();
        },

        // -----------------------------------------------------------------

        fitToWorkArea: function (considerCurrentZoom = false) {
            var fitBBox, newZoomScaleFactor, delta, waRatio, fitRatio,
                fitTargetElem = this.htmlElems.mainImg,
                waBBox = this.htmlElems.workArea.getBoundingClientRect(),
                wazBBox = this.htmlElems.workAreaZoom.getBoundingClientRect();


            fitBBox = fitTargetElem.getBoundingClientRect();

            if (considerCurrentZoom && this.localState.workAreaZoom.scale > this.localState.workAreaZoom.currentFitScale) {

                let offsetX = this.localState.workAreaZoom.currentPanelOffset - (this.sidebarPanel.width + 10)
                if (offsetX != 0) {
                    this.localState.workAreaZoom.currentPanelOffset = (this.sidebarPanel.width + 10);
                }
                newZoomScaleFactor = ((waBBox.width + offsetX) / waBBox.width);
                delta = {
                    x: offsetX * newZoomScaleFactor,
                    y: 0
                }

                console.log("fitToWorkArea: delta", delta, "zoomFactor", newZoomScaleFactor);

                let newScale = this.localState.workAreaZoom.scale * newZoomScaleFactor;

                this.updateWorkAreaZoom({ scale: newScale, delta: delta });
            } else {
                this.localState.workAreaZoom.currentPanelOffset = this.sidebarPanel.width + 10;
                waBBox.width -= (this.sidebarPanel.width + 10);

                waRatio = waBBox.width / waBBox.height;
                fitRatio = fitBBox.width / fitBBox.height;

                if (fitRatio > waRatio) {
                    newZoomScaleFactor = waBBox.width / fitBBox.width;
                } else {
                    newZoomScaleFactor = waBBox.height / fitBBox.height;
                }
                newZoomScaleFactor *= 0.97;

                // newZoomScaleFactor = parseFloat(newZoomScaleFactor.toFixed(6));

                /* Incremento necessarios nos offsets para o correto posicionamento da pagina scaled no workArea
                OBS: temos que levar em consideracao que o transformOrigin do scale é o [0,0] do waz e por isso
                        a posicao pageBBox.[x,y] nao se mantem depois do scale e por isso deve ser calculada */
                delta = {
                    x: (waBBox.width / 2) - (fitBBox.width * newZoomScaleFactor / 2)                   // posicao left que a pagina fitted tem que ter
                        - (((fitBBox.x - wazBBox.x) * newZoomScaleFactor) + (wazBBox.x - waBBox.x)),  // posicao da pagina (ref aa wa) jah levando o scale em consideracao

                    y: (waBBox.height / 2) - (fitBBox.height * newZoomScaleFactor / 2)
                        - (((fitBBox.y - wazBBox.y) * newZoomScaleFactor) + (wazBBox.y - waBBox.y))
                };

                this.localState.workAreaZoom.currentFitScale = this.localState.workAreaZoom.scale * newZoomScaleFactor;

                this.updateWorkAreaZoom({ scale: this.localState.workAreaZoom.currentFitScale, delta: delta });

            }
            // this.ACT_uiUpdate({ workArea : { zoom : { 
            //         scale : this.localState.workAreaZoom.scale * newZoomScaleFactor,
            //         delta : delta 
            //     } } });            
        },

        // -----------------------------------------------------------------

        onFullscreenChange: function () {
            //            requestAnimationFrame(() => {
            //            this.$nextTick(function() {
            setTimeout(() => {
                this.fitToWorkArea();
            }, 200);
        },

        refreshFocusedAnnotationItem() {
            this.$nextTick(() => {
                evtBus.$emit('evt_annotationItem_onFocus', { annotationId: this.localState.active.tool.item?.id || null });
            });
        },

        refreshSelectedAnnotationItem() {
            this.$nextTick(() => {
                setTimeout(() => {
                    evtBus.$emit('evt_annotationItem_onSelect', { annotationId: this.localState.selected.tool?.id || null });
                }, 200);
            });
        },

        changeSelectedTool(tool, force = false) {
            if (this.segmentationFixToolEnabled)
                return;
            this.localState.selected.tool = this.localState.selected.tool?.id == tool?.id && !force ? null : tool;
            evtBus.$emit('evt_tool_onChangeSelected', { toolId: this.localState.selected.tool?.id || null });
            this.refreshPopupAnotacaoOpenerVisibility();
            this.refreshSelectedAnnotationItem();
        },

        setActiveTool(tool, toolPt) {

            // Se não mudou o tool ativo
            if (tool?.id == this.localState.active.tool.item?.id) {
                this.localState.active.tool.toolPt = toolPt;
                return;
            }
            const foundTool = this.jobTools.find(t => t.id == tool?.id);
            // console.log("setActiveTool: ", foundTool, toolPt);
            this.localState.active.tool.item = foundTool;
            this.localState.active.tool.toolPt = toolPt;
            this.localState.active.tool.toolOffset = {
                x: 0,
                y: 0
            }

            this.refreshPopupAnotacaoOpenerVisibility();
            this.refreshFocusedAnnotationItem();
        },

        deleteSelectedTool() {
            console.debug("deleteSelectedTool", this.localState.selected.tool?.id);
            if (this.localState.selected.tool == null)
                return;
            if (this.localState.mov.type == gConsts.mov.types.TOOL_CREATION)
                return;
            const deleteTool = this.localState.selected.tool;
            this.jobTools = this.jobTools.filter(t => t.id != deleteTool.id);
            this.updateJobToolsOnStore('delete', deleteTool);
            const sameLabelTools = this.jobTools.filter(t => t.label.id == deleteTool.label.id);
            const newActiveTool = sameLabelTools.length > 0 ? sameLabelTools[sameLabelTools.length - 1] : null;
            this.changeSelectedTool(newActiveTool);
        },

        addActiveToolPts(payload) {
            if (this.localState.active.tool.item == null)
                return;
            if (utils.numToolPts(this.localState.active.tool.item.attrib.type) == this.localState.active.tool.item.coords.pts.length)
                return;
            var newPts = {},
                addedPts = 0;

            const toolCurrentPts = this.localState.active.tool.item.coords.pts;
            // se payload nao tem 'newPts'
            if (!('newPts' in payload) && ('tool_pt' in payload)) {
                // estamos criando uma tool e adicionando um novo ponto (duplicando o mov.toolPt na mov.tool)
                newPts[payload.tool_pt] = {
                    x: toolCurrentPts[payload.tool_pt].x,
                    y: toolCurrentPts[payload.tool_pt].y
                }
            } else if ('newPts' in payload) {
                newPts = payload.newPts;
            }

            for (const [index, newPt] of Object.entries(newPts)) {
                toolCurrentPts.splice(parseInt(index) + addedPts, 0, newPt); // a cada ponto adicionado, index fica defasado e precisa ser padded
                addedPts++
            }

            this.$updateJobToolsOnStore('update.add_pts', this.localState.active.tool.item);
        },

        updateActiveToolPts(payload) {
            if (this.localState.active.tool.item == null)
                return;
            if (('pts' in payload) && (payload.pts != null)) {
                for (const [key, value] of Object.entries(payload.pts)) {
                    this.localState.active.tool.item.coords.pts[key].x = value.x;
                    this.localState.active.tool.item.coords.pts[key].y = value.y;
                }
                this.$updateJobToolsOnStore('update', this.localState.active.tool.item);
            } else if (('delPts' in payload) && (payload.delPts != null)) {
                for (const delPtIndex of payload.delPts) {
                    this.localState.active.tool.item.coords.pts.splice(delPtIndex, 1);
                }
                this.$updateJobToolsOnStore('update.delete_pts', this.localState.active.tool.item);
            }
        },

        updateActiveToolStore() {
            if (this.localState.active.tool.item == null)
                return;
            this.$updateJobToolsOnStore('update', this.localState.active.tool.item);
        },

        refreshActiveToolLocations(evt) {
            if (this.localState.active.tool.item == null)
                return;
            // Se o drag da tool terminou em outro dente, associamos ela a este novo dente
            if ((this.localState.active.dente != null) && (this.localState.active.tool.item.dente != this.localState.active.dente.label.id)) {
                this.localState.active.tool.item.dente = this.localState.active.dente.label.id;
                console.log("refreshActiveToolLocations: tool dente updated: ", this.localState.active.tool.item.dente);
            }
            this.localState.active.tool.item.locations.external.list = Array.from(this.localState.active.externalLocations);
            if (this.localState.active.tool.item.dente == this.localState.active.dente?.label?.id) {
                this.localState.active.tool.item.locations.internal.faces.list = this.localState.active.internalLocations.faces;
                this.localState.active.tool.item.locations.internal.portions.list = this.localState.active.internalLocations.portions;
            }
            this.localState.active.tool.item.locations.regions.list = Array.from(this.localState.active.toothRegion);
            this.localState.active.tool.item.locations.especificacao = this.localState.active.location.especificacao;
            this.updateJobToolsOnStore('update', this.localState.active.tool.item);
        },

        applyActiveToolDragMovement(evt) {
            if (this.localState.mov.type != gConsts.mov.types.TOOL_DRAG) {

                // Se for drag de um tool tipo PONTO, o handle drag é utilizado.
                if (this.localState.mov.type == gConsts.mov.types.HANDLE_DRAG && this.localState.active.tool.item?.attrib.type == gConsts.tool.attrib.types.PONTO) {
                    this.refreshActiveToolLocations(evt);
                }
                return
            }

            if (this.localState.active.tool.item == null)
                return;

            if (this.localState.mov.active)
                return;

            if (this.localState.active.tool.toolOffset.x == 0 && this.localState.active.tool.toolOffset.y == 0)
                return;


            this.localState.active.tool.item.coords.pts.forEach((pt, idx) => {
                pt.x += this.localState.active.tool.toolOffset.x;
                pt.y += this.localState.active.tool.toolOffset.y;
            });

            // Se o drag da tool terminou em outro dente, associamos ela a este novo dente
            if ((this.localState.active.dente != null) && (this.localState.active.tool.item.dente != this.localState.active.dente.label.id)) {
                this.localState.active.tool.item.dente = this.localState.active.dente.label.id;
                console.log("tool dente updated: ", this.localState.active.tool.item.dente);
            }
            this.localState.active.tool.toolOffset = { x: 0, y: 0 };
            this.refreshActiveToolMoveOffset();
            // this.ACT_toolUpdate(payload);
            this.$updateJobToolsOnStore('update', this.localState.active.tool.item);
        },

        handleActiveToolMovement(delta) {
            // console.log("handleActiveToolMovement: ", delta);
            if ([gConsts.mov.types.TOOL_HOVER, -1].includes(this.localState.mov.type))
                return;

            if (this.localState.active.tool.item == null || delta == null)
                return;
            // console.log("mov.toolOffset: ", JSON.stringify(this.localState.active.tool.toolOffset));

            if ([gConsts.mov.types.HANDLE_DRAG, gConsts.mov.types.TOOL_DRAG].includes(this.localState.mov.type) &&
                this.localState.active.tool.item.state.input == gConsts.tool.state.inputs.BOT) {
                // Salva os pontos originais se for tool originado do BOT
                this.localState.active.tool.item.coords.ptsOriginal = _.cloneDeep(this.localState.active.tool.item.coords.pts);
                this.localState.active.tool.item.state.input = gConsts.tool.state.inputs.MIXED;
            }

            switch (this.localState.mov.type) {
                case gConsts.mov.types.TOOL_CREATION:
                case gConsts.mov.types.HANDLE_DRAG:
                    if (this.localState.active.tool.item.coords.pts[this.localState.active.tool.toolPt] != null) {
                        // this.ACT_toolUpdate({ delta: delta, drag_type: this.activeToolDragType, tool_id: this.localState.active.tool.item.id, tool_pt: this.localState.active.tool.toolPt});
                        this.localState.active.tool.item.coords.pts[this.localState.active.tool.toolPt].x += delta.x;
                        this.localState.active.tool.item.coords.pts[this.localState.active.tool.toolPt].y += delta.y;
                        // console.log("tool.coords.pts[mov.toolPt]: ", JSON.stringify(this.localState.active.tool.item.coords.pts[this.localState.active.tool.toolPt]));
                    }
                    this.$updateJobToolsOnStore('update', this.localState.active.tool.item);
                    break;
                case gConsts.mov.types.LABEL_DRAG:
                    this.localState.active.tool.item.label.vLabel.x += delta.x;
                    this.localState.active.tool.item.label.vLabel.y += delta.y;
                    console.log("tool.label.vLabel: ", JSON.stringify(this.localState.active.tool.item.label.vLabel));
                    this.$updateJobToolsOnStore('update', this.localState.active.tool.item);
                    break
                case gConsts.mov.types.TOOL_DRAG:
                    // Aplico transformacoes localmente so se for tool_drag]
                    this.localState.active.tool.toolOffset.x += delta.x;
                    this.localState.active.tool.toolOffset.y += delta.y;
                    this.refreshActiveToolMoveOffset();
                    break;
            }
        },

        refreshActiveToolMoveOffset() {
            if (this.toolCMPs.outer[this.localState.active.tool.item.id]) {
                this.toolCMPs.outer[this.localState.active.tool.item.id].$refs.toolContainer.style.setProperty('--tool-move-offset-x', `${this.localState.active.tool.toolOffset.x}px`);
                this.toolCMPs.outer[this.localState.active.tool.item.id].$refs.toolContainer.style.setProperty('--tool-move-offset-y', `${this.localState.active.tool.toolOffset.y}px`);
            }
        },

        updateJobToolsOnStore(type, tool) {
            // console.log("updateJobToolsOnStore: ", type, tool?.id || 'none');
            this.$store.dispatch('ACT_jobToolsUpdate', { type: type, tool: tool });
        },

        updateActiveDenteOnStore(dente) {
            // console.log("updateActiveDenteOnStore: ", dente);
            this.ACT_runtimeUpdate({ active: { dente: dente || null } });
        },

        createNewTool(payload) {
            if (!payload || !payload.attrib || !payload.coords?.pts?.length)
                return null;
            var storeRuntime = this.$store.state.runtime,
                storeProjectNodes = this.$store.state.setup.proj.nodes;

            const newSerial = this.counters.toolSerial++;
            // console.log("createNewToolcreateNewTool: ", payload.attrib.type, toolLabelId, newSerial);
            // console.log("createNewTool internalLocations: ", payload.locations);

            const canHaveLocations = payload.attrib.type == gConsts.tool.attrib.types.PONTO
            const toolLabelId = payload?.label?.id || this.localState.active.node.label;
            const toolLabelNode = storeProjectNodes.get(toolLabelId);
            if (!toolLabelNode)
                return null;
            const toolLabelLayer = payload?.label?.layer || this.localState.active.node.layer;
            const toolDente = payload.dente || this.localState.active.dente?.label?.id;

            const newTool = {
                id: 'tool' + '_' + payload.attrib.type + '_' + toolLabelId + '[' + newSerial + ']',
                attrib: {
                    type: payload.attrib.type,
                    iAMethod: payload.attrib.iAMethod || gConsts.tool.attrib.iaMethods.NONE,
                },
                label: {
                    text: toolLabelNode?.layout?.label,
                    id: toolLabelId,
                    layer: toolLabelLayer,
                    vLabel: { x: 0, y: 0 },
                },
                state: {
                    confidence: gConsts.tool.state.confidence.OK,
                    marked: false,
                    input: payload?.state?.input || gConsts.tool.state.inputs.MANUAL
                },
                elem: {
                    index: storeRuntime.active.elemIdx,
                    id: this.GET_activeElem.id,
                    slice: this.GET_activeElem.img.slice
                },
                coords: {
                    pts: payload.coords.pts,
                    ptsOriginal: null,
                },
                locations: {
                    external: {
                        list: canHaveLocations && this.labelAnnotationPermissions.externalLocation ? payload.locations?.external || [] : [],
                        custom: ''
                    },
                    regions: {
                        list: canHaveLocations && this.labelAnnotationPermissions.toothRegion ? payload.locations?.regions || [] : [],
                        custom: ''
                    },
                    internal: {
                        faces: {
                            list: canHaveLocations && this.labelAnnotationPermissions.internalLocation ? payload.locations?.internal?.faces || [] : [],
                            custom: ''
                        },
                        portions: {
                            list: canHaveLocations && this.labelAnnotationPermissions.internalLocation ? payload.locations?.internal?.portions || [] : [],
                            custom: ''
                        }
                    },
                    especificacao: this.localState.active.location.especificacao,
                },
                dente: toolDente || null,
                qualifiers: {
                    list: payload.qualifiers || [],
                    custom: ''
                },
            }
            this.jobTools.push(newTool);

            console.log("createNewTool.newTool: ", JSON.stringify(newTool));

            evtBus.$emit('evt_tool_newTool', { tool_id: newTool.id, tool_label_id: newTool.label.id });

            return newTool;
        },

        updateWorkAreaMovType() {
            evtBus.$emit('evt_workArea_movType_update', { movType: this.localState.mov.type });
        },

        updateWorkAreaZoom(payload) {
            if ('delta' in payload) {
                this.localState.workAreaZoom.offset.x += payload.delta.x;
                this.localState.workAreaZoom.offset.y += payload.delta.y;
            }
            if ('scale' in payload) {
                this.localState.workAreaZoom.scale = payload.scale;
            }
            evtBus.$emit('evt_workArea_zoom_update', payload);
            this.$updateWorkAreaZoomOnStore(payload);
            // this.ACT_uiUpdate({ workArea : { zoom : { scale : this.localState.workAreaZoom.scale } } });
        },

        updateWorkAreaZoomOnStore(payload) {
            this.ACT_uiUpdate({ workArea: { zoom: payload } });
        },

        updateToolVisibleLabel(label) {
            this.localState.tool.visibleLabel = label ?? null;
            this.updateToolVisibleLocations(label);
        },

        updateToolVisibleLocations(labelId) {
            var projNodes = this.$store.state.setup.proj.nodes;

            this.localState.tool.visibleLocations.clear();
            if (labelId !== null) {
                const labelAnnotationType = anotacaoUtils.getLabelAnnotationTypeById(labelId);
                const labelTools = this.jobTools.filter(t => t.label.id == labelId);
                labelTools.forEach(tool => {
                    if (labelAnnotationType == gConsts.node.report.annotation.types.TOOTH && tool.dente != null) {
                        this.localState.tool.visibleLocations.add(tool.dente);
                    }
                    if ([gConsts.node.report.annotation.types.RTOOTH, gConsts.node.report.annotation.types.PROX_ANAT_RTOOTH, gConsts.node.report.annotation.types.ANAT_RTOOTH].includes(labelAnnotationType)) {
                        const denteRegions = tool.locations?.regions?.list?.filter(location => location.startsWith('lb_dente')) || [];
                        denteRegions.forEach(region => {
                            this.localState.tool.visibleLocations.add(region);
                        });
                    }

                    if ([gConsts.node.report.annotation.types.ANAT_RTOOTH, gConsts.node.report.annotation.types.ANAT_ONLY].includes(labelAnnotationType)) {
                        const anatLocations = tool.locations?.external?.list?.filter(location => location.startsWith('lb_r'));
                        anatLocations.forEach(anatLocation => {
                            this.localState.tool.visibleLocations.add(anatLocation);
                        });
                    }
                });
            }
        },

        canShowPopupAnotacaoOpener() {
            if (!this.localState.active.tool.item)
                return false;

            if (!this.localState.active.node.label)
                return false;

            if (this.localState.mov.active || this.localState.mov.dragging)
                return false;

            const toolAnnotation = this.localState.active.tool.item;
            const annotationLabel = this.activeNodeLabelItem;
            if (!this.toolCMPs.outer[toolAnnotation.id])
                return false;

            if (!this.isReportAnnotationTool(toolAnnotation))
                return false;
            if (annotationLabel.id != toolAnnotation.label.id)
                return false;

            if (!anotacaoUtils.canLabelEditAnnotations(annotationLabel.id))
                return false;

            return true;
        },

        refreshPopupAnotacaoOpenerVisibility() {
            if (!this.canShowPopupAnotacaoOpener()) {
                evtBus.$emit('evt_popupAnotacao_opener_hide');
                return;
            }

            const toolAnnotation = this.localState.active.tool.item;
            const annotationLabel = this.activeNodeLabelItem;
            // console.log("refreshPopupAnotacaoOpenerVisibility: toolAnnotation", {...toolAnnotation});
            // console.log("refreshPopupAnotacaoOpenerVisibility: annotationLabel", {...annotationLabel});

            const toolElement = this.toolCMPs.outer[toolAnnotation.id].$refs.toolContainer;
            const toolBodyAndHandles = toolElement.querySelector('#g_tool_bodyAndHandles');
            // console.log("refreshPopupAnotacaoOpenerVisibility: toolElement", toolElement);
            // console.log("refreshPopupAnotacaoOpenerVisibility: toolAnnotation", toolAnnotation)
            const elementWindowPosition = toolBodyAndHandles?.getBoundingClientRect() || toolElement.getBoundingClientRect();
            evtBus.$emit('evt_popupAnotacao_opener_show', {
                labelNodeId: toolAnnotation.label.id,
                annotationId: toolAnnotation.id,
                position: {
                    x: elementWindowPosition.left + 10,
                    y: elementWindowPosition.top - 20,
                }
            });
        },

        buildInternalLocationTools() {
            if (!this.constants.featureFlags.localizacoesAutomaticas)
                return;
            if (this.localState.internalLocation.tools.length > 0)
                return;
            if (this.jobTools.length == 0)
                return;
            const internalLocationBuilder = new InternalLocationsToolBuilder(this.jobTools);
            console.time('medidor.buildInternalLocationTools: building internal location tools');
            this.jobTools.forEach(tool => {
                if (tool.label.id.startsWith('lb_dente') && tool.attrib.type == gConsts.tool.attrib.types.CURVA) {
                    this.localState.internalLocation.tools.push(...internalLocationBuilder.buildTools(tool));
                }
            });
            this.localState.internalLocation.canDisplay = true;
            console.timeEnd('medidor.buildInternalLocationTools: building internal location tools');
        },

        rebuildToothInternalLocationTools(toothTool) {
            // console.log('rebuildToothInternalLocationTools', {...toothTool})
            if (!toothTool.dente)
                return;
            this.localState.internalLocation.tools = this.localState.internalLocation.tools
                .filter(internalTool => internalTool.dente != toothTool.dente)

            this.$nextTick(() => {
                const internalLocationBuilder = new InternalLocationsToolBuilder(this.jobTools);
                const newInternalTools = internalLocationBuilder.buildTools(toothTool)
                this.localState.internalLocation.tools.push(...newInternalTools)
            })
        },

        buildDenticaoRect() {
            if (!this.constants.featureFlags.localizacoesAutomaticas)
                return;
            if (this.constants.denticaoRect.width > 0 && this.constants.denticaoRect.height > 0) {
                return;
            }
            this.constants.mediaDente = {
                width: this.GET_jobMetrics.teeth.meanWidth || 100,
                height: this.GET_jobMetrics.teeth.meanHeight || 220,
            }
            const rebordoSuperiorTool = this.jobTools.find(tool => tool.label.id == 'lb_cRebAlvSup' && gConsts.layer.locations.ANAT_CONTOURS.startsWith(tool.label.layer));
            const rebordoInferiorTool = this.jobTools.find(tool => tool.label.id == 'lb_cRebAlvInf' && gConsts.layer.locations.ANAT_CONTOURS.startsWith(tool.label.layer));
            const rebordoSuperiorBoundingRect = utils.getBoundingRect(rebordoSuperiorTool.coords.pts);
            const rebordoSuperiorMiddlePointY = rebordoSuperiorBoundingRect.y + (rebordoSuperiorBoundingRect.height / 2);
            const rebordoInferiorBoundingRect = utils.getBoundingRect(rebordoInferiorTool.coords.pts);
            const rebordoInferiorMiddlePointY = rebordoInferiorBoundingRect.y + (rebordoInferiorBoundingRect.height / 2);

            // const rebordoMiddlePointY = (rebordoInferiorBoundingRect.y + rebordoInferiorBoundingRect.height) - (this.constants.mediaDente.height * 0.5);
            const rebordoMiddlePointY = ((rebordoSuperiorBoundingRect.y + rebordoSuperiorBoundingRect.height) + rebordoInferiorBoundingRect.y) / 2
            // const rebordoMiddlePointY = ((rebordoInferiorBoundingRect.y + (rebordoInferiorBoundingRect.height / 2)) - (this.constants.mediaDente.height / 3))
            // const rebordoMiddlePointY = (rebordoInferiorMiddlePointY + rebordoSuperiorMiddlePointY) / 2;
            // A altura de 2 dentes mais uma distancia aproximada para o espaco no meio dos dentes
            const height = this.constants.mediaDente.height * 2.25;
            this.constants.denticaoRect = {
                width: this.GET_jobMetrics.arch.width,
                height: height,
                x: rebordoSuperiorBoundingRect.x,
                y: rebordoMiddlePointY - (height / 2),
            }

            // monto uma denticao usando o rect de denticao e dividindo em retangulos iguais
            const arcadaDenteCount = PERMANENTE_TOOTH_COUNT / 2;
            const meanDenteWidth = this.constants.denticaoRect.width / arcadaDenteCount;
            const molarDenteWidth = meanDenteWidth * 1.3;
            // 6 molares por arcada
            const availableNormalDenteWidthSpace = this.constants.denticaoRect.width - (molarDenteWidth * 6);
            const normalDenteWidth = availableNormalDenteWidthSpace / (arcadaDenteCount - 6);
            let currentWidthOffset = 0;
            this.localState.probableTooth.tools = gConsts.denticao.dentes.PERMANENTE
                .sort((a, b) => {
                    const aDetails = toothUtils.getToothDetails(+a);
                    const bDetails = toothUtils.getToothDetails(+b);
                    let aOrderIndex = toothUtils.getToothHorizontalOrderIndex(+a, 'complete');
                    let bOrderIndex = toothUtils.getToothHorizontalOrderIndex(+b, 'complete');
                    aOrderIndex = aDetails.posicao == 'superior' ? aOrderIndex : aOrderIndex + arcadaDenteCount;
                    bOrderIndex = bDetails.posicao == 'superior' ? bOrderIndex : bOrderIndex + arcadaDenteCount;
                    return aOrderIndex - bOrderIndex;
                })
                .map((toothNumber, index) => {
                    const detalhesDente = toothUtils.getToothDetails(+toothNumber);
                    const denteOrderIndex = toothUtils.getToothHorizontalOrderIndex(+toothNumber, 'complete');
                    // Caso volte para o inicio da arcada, reseto o offset
                    if (denteOrderIndex == 0) {
                        currentWidthOffset = 0;
                    }
                    let denteWidth = 0;
                    // Dou um tamanho maior para os molares
                    if (toothUtils.isMolarTooth(+toothNumber)) {
                        denteWidth = molarDenteWidth;
                    } else {
                        denteWidth = normalDenteWidth;
                    }
                    const denteRect = {
                        x: this.constants.denticaoRect.x + currentWidthOffset,
                        y: detalhesDente.posicao == 'superior' ? this.constants.denticaoRect.y : (this.constants.denticaoRect.y + this.constants.denticaoRect.height) - this.constants.mediaDente.height,
                        width: denteWidth,
                        height: this.constants.mediaDente.height,
                    }
                    currentWidthOffset += denteWidth;
                    const denteLabelId = `lb_dente${toothNumber}`;
                    return {
                        id: `tool_${gConsts.tool.attrib.types.PATH}_${denteLabelId}[${index}]`,
                        attrib: {
                            type: gConsts.tool.attrib.types.PATH,
                            iAMethod: gConsts.tool.attrib.iaMethods.NONE,
                        },
                        label: {
                            text: `${toothNumber}`,
                            id: denteLabelId,
                            layer: gConsts.layer.locations.TEETH_PROVAVEL,
                            vLabel: { x: 0, y: 0 },
                            vLabelOffset: { x: 40, y: 0 },
                        },
                        state: {
                            confidence: gConsts.tool.state.confidence.OK,
                            marked: false,
                            input: gConsts.tool.state.inputs.MANUAL
                        },
                        elem: {
                            index: 0,
                        },
                        coords: {
                            pts: [
                                { x: denteRect.x + denteRect.width, y: denteRect.y },
                                { x: denteRect.x, y: denteRect.y },
                                { x: denteRect.x, y: denteRect.y + denteRect.height },
                                { x: denteRect.x + denteRect.width, y: denteRect.y + denteRect.height },
                            ]
                        },
                        dente: denteLabelId,
                    }
                })
            this.localState.probableTooth.canDisplay = true;
        },

        observeSidebarPanelResize() {
            const sidebarPanelElement = document.getElementById('div_sidebarPanels');
            if (!sidebarPanelElement)
                return;
            this.sidebarPanel.observer = new ResizeObserver((entries) => {
                entries.forEach(entry => {
                    // console.debug('medidor.observeSidebarPanelResize: sidebar panel resized', entry.contentRect.width);
                    this.sidebarPanel.width = entry.contentRect.width;
                });
            });
            this.sidebarPanel.observer.observe(sidebarPanelElement);
        },

        disconnectSidebarPanelResizeObserver() {
            if (this.sidebarPanel.observer) {
                this.sidebarPanel.observer.disconnect();
                this.sidebarPanel.observer = null;
            }
        },

        clearSegmentationFixSelection() {
            if (this.segmentationFix.processing)
                return;
            if (this.segmentationFix.result.pending_confirmation)
                return;
            this.segmentationFix.active = false;
            this.segmentationFix.selection.pts = [];
            this.segmentationFix.selection.rect = {
                x: 0,
                y: 0,
                width: 0,
                height: 0,
                angle: 0,
            };
            this.segmentationFix.selection.path = {
                length: 0,
                d: '',
            };
            evtBus.$emit('evt_segmentacaoFix_hideTrigger');
        },

        createSegmentationFixSelection(mousePos) {
            if (!this.segmentationFixToolEnabled)
                return;

            this.segmentationFix.selection.mousePos = mousePos;

            const middlePoint = {
                x: mousePos.x,
                y: mousePos.y,
            }


            let denteRect = {
                width: this.constants.mediaDente.width * 1.2,
                height: this.constants.mediaDente.height * 1.4,
            }

            const activeDenteTool = this.localState.active.dente;
            let rotateAngleDegrees = 0;
            if (activeDenteTool) {
                const toothDetails = toothUtils.getToothDetailsByLabelId(activeDenteTool.label.id);
                if (toothUtils.isMolarTooth(+toothDetails.numero)) {
                    denteRect.width = this.constants.mediaDente.width * 1.6;
                }

                const toothLongAxisPts = toothUtils.getLongAxisLinePoints(activeDenteTool, this.jobTools);
                if (toothLongAxisPts.length == 2) {
                    const vlongAxisLine = this.$Victor.fromObject(toothLongAxisPts[1]).subtract(this.$Victor.fromObject(toothLongAxisPts[0]));
                    if (toothDetails.posicao == 'inferior') {
                        vlongAxisLine.invertY();
                    } else if (toothDetails.posicao == 'superior') {
                        vlongAxisLine.invertX();
                    }
                    rotateAngleDegrees = vlongAxisLine.verticalAngleDeg();
                    console.log('medidor.createSegmentationRect: rotateAngleDegrees', activeDenteTool.id, rotateAngleDegrees, toothDetails.posicao);
                }
            } else {
                // Se nao tiver dente ativo, dou um range maior para a selecao
                denteRect.width = this.constants.mediaDente.width * 1.8;
            }

            this.segmentationFix.selection.dente = activeDenteTool?.label?.id;

            let selectionPts = [
                { x: middlePoint.x - (denteRect.width / 2), y: middlePoint.y - (denteRect.height / 2) },
                { x: middlePoint.x + (denteRect.width / 2), y: middlePoint.y - (denteRect.height / 2) },
                { x: middlePoint.x + (denteRect.width / 2), y: middlePoint.y + (denteRect.height / 2) },
                { x: middlePoint.x - (denteRect.width / 2), y: middlePoint.y + (denteRect.height / 2) },
            ]

            this.segmentationFix.selection.rect = {
                x: selectionPts[0].x,
                y: selectionPts[0].y,
                width: selectionPts[1].x - selectionPts[0].x,
                height: selectionPts[2].y - selectionPts[0].y,
                angle: rotateAngleDegrees,
            };

            console.log('medidor.createSegmentationRect: selectionPts', JSON.stringify(selectionPts));

            if (rotateAngleDegrees != 0) {
                const cx = middlePoint.x;
                const cy = middlePoint.y;
                const absoluteSelectionCorners = [
                    { x: - (denteRect.width / 2), y: - (denteRect.height / 2) },
                    { x: + (denteRect.width / 2), y: - (denteRect.height / 2) },
                    { x: + (denteRect.width / 2), y: + (denteRect.height / 2) },
                    { x: - (denteRect.width / 2), y: + (denteRect.height / 2) },
                ]
                const rotateRadians = rotateAngleDegrees * (Math.PI / 180);
                const cos = Math.cos(rotateRadians);
                const sin = Math.sin(rotateRadians);
                const rotatedSelectionCorners = absoluteSelectionCorners.map(corner => {
                    return {
                        x: cx + (corner.x * cos - corner.y * sin),
                        y: cy + (corner.x * sin + corner.y * cos)
                    }
                });
                console.log('medidor.createSegmentationRect: rotatedSelectionCorners', JSON.stringify(rotatedSelectionCorners));
                selectionPts = rotatedSelectionCorners;
            }

            this.segmentationFix.active = true;
            this.segmentationFix.selection.pts = selectionPts;
            const pathString = `M ${selectionPts[0].x} ${selectionPts[0].y} L ${selectionPts[1].x} ${selectionPts[1].y} L ${selectionPts[2].x} ${selectionPts[2].y} L ${selectionPts[3].x} ${selectionPts[3].y} Z`;
            this.segmentationFix.selection.path = {
                length: 0,
                d: pathString,
            };

            this.$nextTick(() => {
                setTimeout(() => {
                    const pathElement = this.$refs.path_segmentationFix;
                    if (!pathElement)
                        return;
                    this.segmentationFix.selection.path.length = pathElement.getTotalLength();
                }, 100);
                this.showSegmentationFixTrigger();
            });

        },

        showSegmentationFixTrigger() {
            if (!this.segmentationFix.active || this.segmentationFix.selection.pts.length == 0)
                return;
            if (!this.$refs.path_segmentationFix)
                return;
            const pathBoundingRect = this.$refs.path_segmentationFix.getBoundingClientRect();
            evtBus.$emit('evt_segmentacaoFix_showTrigger', {
                position: {
                    x: pathBoundingRect.left + (pathBoundingRect.width),
                    y: pathBoundingRect.top - 20,
                },
            });
        },

        async getBase64ImageFromSegmentationFixSelection() {
            const imgElement = document.getElementById('mainImg');
            if (!imgElement)
                return null;

            const base64OriginalImage = await imageUtils.getBase64FromImageUrl(imgElement.src);
            return new Promise((resolve, reject) => {
                const originalImage = new Image();
                originalImage.onload = () => {
                    const selectionRect = this.segmentationFix.selection.rect;
                    console.log('medidor.getBase64ImageFromSegmentationFixSelection: selectionRect', JSON.stringify(selectionRect));
                    const croppedBase64Image = imageUtils.cropRotatedRectangle(originalImage,
                        selectionRect.x + (selectionRect.width / 2),
                        selectionRect.y + (selectionRect.height / 2),
                        selectionRect.width,
                        selectionRect.height,
                        selectionRect.angle
                    );
                    resolve(croppedBase64Image.replace('data:image/jpeg;base64,', ''));
                };
                originalImage.onerror = () => {
                    reject(new Error('medidor.getBase64ImageFromSegmentationFixSelection: failed to load image'));
                };
                originalImage.src = base64OriginalImage;
            })
        },

        async applySegmentationFix() {

            try {
                console.log('medidor.applySegmentationFix: start');
                this.segmentationFix.processing = true;
                const base64Image = await this.getBase64ImageFromSegmentationFixSelection();

                // console.log('medidor.applySegmentationFix: base64Image', base64Image);
                const segmentationFixResult = await this.requestSegmentationFixApi({
                    base64Image: base64Image,
                });
                if (!segmentationFixResult || !segmentationFixResult.pts?.length)
                    return;

                // Os pontos retornados sao referente ao crop apenas. Preciso converter para os pontos da imagem original.
                // Preciso voltar o angulo de rotacao da selecao.
                const selectionRect = this.segmentationFix.selection.rect;
                const rotateRadians = selectionRect.angle * (Math.PI / 180);
                const cos = Math.cos(rotateRadians);
                const sin = Math.sin(rotateRadians);
                const ptsOnImage = segmentationFixResult.pts.map(pt => {
                    const cropX = pt.x - (selectionRect.width / 2);
                    // Eu inverto o Y inicialmente
                    const cropY = (pt.y - (selectionRect.height / 2)) * -1;
                    return {
                        x: selectionRect.x + (selectionRect.width / 2) + (cropX * cos - cropY * sin),
                        y: selectionRect.y + (selectionRect.height / 2) + (cropX * sin + cropY * cos),
                    }
                })

                let pathD = 'M ' + ptsOnImage[0].x + ' ' + ptsOnImage[0].y;
                for (let idx = 1; idx < ptsOnImage.length; idx++) {
                    pathD += ' L ' + ptsOnImage[idx].x + ' ' + ptsOnImage[idx].y
                }

                pathD += ' Z';

                this.segmentationFix.result.path = {
                    length: 0,
                    d: pathD,
                }
                this.segmentationFix.result.dente = this.segmentationFix.selection.dente;
                this.segmentationFix.result.pts = ptsOnImage;
                this.segmentationFix.result.pending_confirmation = true;

                const payload = {
                    result: this.segmentationFix.result,
                    selection: {
                        mousePos: this.segmentationFix.selection.mousePos,
                        rect: this.$refs.path_segmentationFix.getBoundingClientRect(),
                    }
                }

                evtBus.$emit('evt_segmentacaoFix_showConfirmPopup', payload);
                this.setFocusLocation(gConsts.mov.focusLocations.POPUP_CONFIRM_SEGMENTATION_FIX);

                this.$nextTick(() => {
                    setTimeout(() => {
                        const pathElement = this.$refs.path_segmentationFixResult;
                        if (!pathElement)
                            return;
                        this.segmentationFix.result.path.length = pathElement.getTotalLength();
                    }, 50);
                });
            } catch (error) {
                console.error('medidor.applySegmentationFix: error', error);
            } finally {
                this.segmentationFix.processing = false;
            }
        },

        confirmSegmentationFixResult(payload) {
            const result = payload.result;
            if (!result || !result.dente)
                return;

            // Aplica alteracao dos pontos de segmentacao
            const referredDenteTool = this.jobTools.find(tool => tool.label.id == result.dente && tool.label.layer == gConsts.layer.locations.TEETH_SEG);
            if (!referredDenteTool) {
                const foundDenteNode = this.GET_dentesNodes.find(node => node.id == result.dente);
                if (!foundDenteNode)
                    return;
                // Crio dente se nao existir
                const newTool = this.createNewTool({
                    attrib: {
                        type: gConsts.tool.attrib.types.CURVA,
                        iAMethod: gConsts.tool.attrib.iaMethods.UNET_SEG,
                    },
                    label: {
                        id: foundDenteNode.id,
                        layer: foundDenteNode.layout.parent,
                    },
                    dente: result.dente,
                    coords: {
                        pts: this.segmentationFix.result.pts,
                    },
                    state: {
                        input: gConsts.tool.state.inputs.BOT,
                    },
                });
                this.rebuildToothInternalLocationTools(newTool);
                this.updateJobToolsOnStore('add', newTool);
            } else {
                referredDenteTool.coords.pts = this.segmentationFix.result.pts;
                this.rebuildToothInternalLocationTools(referredDenteTool);
                this.updateJobToolsOnStore('update', referredDenteTool);
            }

            console.log('medidor.confirmSegmentationFixResult: result', result);
            this.clearSegmentationFixResult();
        },

        cancelSegmentationFixResult() {
            this.clearSegmentationFixResult();
        },

        clearSegmentationFixResult() {
            this.segmentationFix.processing = false;
            this.segmentationFix.result.dente = null;
            this.segmentationFix.result.pts = [];
            this.segmentationFix.result.pending_confirmation = false;
            this.segmentationFix.result.path = {
                length: 0,
                d: '',
            }
            evtBus.$emit('evt_segmentacaoFix_closeConfirmPopup');
            this.setFocusLocation(gConsts.mov.focusLocations.WORK_AREA);
            this.clearSegmentationFixSelection();
        },

        registerSegmentationFixEventListeners() {
            evtBus.$on('evt_segmentacaoFix_triggerFix', () => {
                this.applySegmentationFix();
            });
            evtBus.$on('evt_segmentacaoFix_confirmResult', (payload) => {
                this.confirmSegmentationFixResult(payload);
            });
            evtBus.$on('evt_segmentacaoFix_cancelResult', () => {
                this.cancelSegmentationFixResult();
            });
        }

    },

    beforeUpdate() {
        // console.log('beforeUpdate medidor');
    },


    // =========================================================================================
    // Lifecycle hooks

    created() {
        evtBus.$on('evt_toolCreation', (tool, tool_innerCMP, tool_outerCMP) => {
            this.toolCMPs.inner[tool.id] = tool_innerCMP;
            this.toolCMPs.outer[tool.id] = tool_outerCMP;

            if (this.localState.active.node.label && this.localState.active.node.layer) {
                evtBus.$emit('evt_activateNode', { label: this.localState.active.node.label, layer: this.localState.active.node.layer });
            }

            if (this.localState.active.node.label) {
                this.refreshPopupAnotacaoOpenerVisibility();
            }

            // console.log("evt_toolCreation: ", tool, tool_innerCMP, tool_outerCMP);
        });

        evtBus.$on('evt_toolDestruction', (toolId) => {
            delete this.toolCMPs.inner[toolId];
            delete this.toolCMPs.outer[toolId];
        });

        evtBus.$on('evt_toolAction', (type, payload) => {
            if (type == 'addPts') {
                this.addActiveToolPts(payload);
            } else if (type == 'updatePts') {
                this.updateActiveToolPts(payload);
            } else if (type == 'deleteTool') {
                this.deleteSelectedTool();
            } else if (type == 'updateToolStore') {
                this.updateActiveToolStore();
            }
        });

        evtBus.$on('evt_activateNode', (payload) => {
            this.localState.active.node.label = payload.label;
            this.localState.active.node.layer = payload.layer;
        });

        evtBus.$on('evt_medidor_fitToWorkArea', () => {
            this.fitToWorkArea(false);
            // this.fitToWorkArea(true);
        }),

            evtBus.$on('evt_sidebarPanel_onCollapse', () => {
                setTimeout(() => {
                    this.setFocusLocation(gConsts.mov.focusLocations.WORK_AREA);
                }, 150);
            });

        evtBus.$on('evt_sidebarPanel_onExpanded', (panelId) => {
            evtBus.$emit('evt_labelSearchPopup_close');
            setTimeout(() => {
                if (panelId == 'relatorio') {
                    this.setFocusLocation(gConsts.mov.focusLocations.SIDEBAR_PANELS_RELATORIO);
                } else if (panelId == 'pesquisa') {
                    this.setFocusLocation(gConsts.mov.focusLocations.SIDEBAR_PANELS_PESQUISA);
                } else if (panelId == 'anatomia') {
                    this.setFocusLocation(gConsts.mov.focusLocations.SIDEBAR_PANELS_ANATOMIA);
                }
            }, 150);
        });

        evtBus.$on('evt_popupAnotacao_onOpen', (payload) => {
            this.setFocusLocation(gConsts.mov.focusLocations.POPUP_ANOTACAO);
            this.localState.focused.toolIds.clear();
            this.localState.focused.toolIds.add(payload.annotationId);
            this.localState.focused.dentes = new Set(payload.annotation?.localizacao?.dentes?.map(dente => dente.id) || []);
            // this.localState.focused.dentes.clear();
            // payload.annotation?.localizacao?.dentes?.forEach(dente => {
            //     this.localState.focused.dentes.add(dente.id);
            // });
            this.localState.focused.regioesAnatomicas = new Set(payload.annotation?.localizacao?.regioesAnatomicas?.map(regiao => regiao.id) || []);
            // this.localState.focused.regioesAnatomicas.clear();
            // payload.annotation?.localizacao?.regioesAnatomicas?.forEach(regiao => {
            //     this.localState.focused.regioesAnatomicas.add(regiao.id);
            // });
        });

        evtBus.$on('evt_popupAnotacao_onClose', () => {
            this.setFocusLocation(gConsts.mov.focusLocations.WORK_AREA);
            this.localState.focused.toolIds.clear();
            this.localState.focused.dentes.clear();
            this.localState.focused.regioesAnatomicas.clear();

            this.$nextTick(() => {
                setTimeout(() => {
                    evtBus.$emit('evt_annotationItem_onSelect', { annotationId: this.localState.selected.tool?.id || null });
                }, 200);
            });
        });

        evtBus.$on('evt_tool_displayLabel', (payload) => {
            this.$updateToolVisibleLabel(payload.label);
        });

        evtBus.$on('evt_labelSearchPopup_onClose', () => {
            if (this.localState.focusLocation == gConsts.mov.focusLocations.LABEL_SEARCH_POPUP) {
                this.setFocusLocation(gConsts.mov.focusLocations.WORK_AREA);
            }
        });

        evtBus.$on('evt_annotationItem_select', (payload) => {
            // console.log('evt_annotationItem_select: ', payload);
            if (this.localState.focusLocation == gConsts.mov.focusLocations.POPUP_ANOTACAO)
                return;
            if (!payload.annotationId)
                return;

            const annotationTool = this.jobTools.find(tool => tool.id == payload.annotationId);
            if (!annotationTool)
                return;
            if (this.localState.active.tool.item?.id == annotationTool.id && !payload.force) {
                this.setActiveTool(null, -1);
                this.changeSelectedTool(null);
                return;
            }

            const labelReportNode = this.GET_reportNodes.find(node => node.id == annotationTool.label.id);
            if (!labelReportNode)
                return;

            if (this.localState.active.node.label != labelReportNode.id) {
                evtBus.$emit('evt_relatorioDinamico_activateNode', { nodeId: labelReportNode.id, nodeType: gConsts.node.layout.types.LABEL });
            }
            this.setActiveTool(annotationTool, 0);
            this.changeSelectedTool(annotationTool, payload.force);
        });

        evtBus.$on('evt_annotationItem_focus', (payload) => {
            if (this.localState.focusLocation == gConsts.mov.focusLocations.POPUP_ANOTACAO)
                return;
            if (!payload.annotationId)
                return;
            if (payload.annotationId.startsWith('dentes_seg_')) {
                const denteId = payload.annotationId.split('dentes_seg_')[1];
                // console.log('evt_annotationItem_onFocus: dente segmentado', denteId);
                this.localState.focused.dentes = new Set([denteId]);
                // this.localState.focused.dentes.clear();
                // this.localState.focused.dentes.add(denteId);
                return;
            }

            const annotationTool = this.jobTools.find(tool => tool.id == payload.annotationId);
            if (!annotationTool)
                return;

            const labelReportNode = this.GET_reportNodes.find(node => node.id == annotationTool.label.id);
            if (!labelReportNode)
                return;

            const annotationsToFocus = []
            const associationType = anotacaoUtils.getAssociationTypeByAnnotationType(labelReportNode.annotation?.type);
            // Caso seja associacao em grupo, todas as anotacoes sao focadas
            if (associationType == gConsts.node.report.annotation.association.GROUP) {
                annotationsToFocus.push(...labelReportNode.annotation.list);
            } else {
                const foundAnnotation = labelReportNode.annotation.list.find(annotation => annotation.id == annotationTool.id);
                if (foundAnnotation)
                    annotationsToFocus.push(foundAnnotation);
            }

            if (annotationsToFocus.length == 0)
                return;

            // console.log('evt_annotationItem_onFocus: annotationsToFocus', annotationsToFocus);
            this.localState.tool.visibleLocations.clear();
            // O vue atualiza a interface corretamente se apenas resetar os sets.
            // Se apenas limpar ele nao atualiza.
            this.localState.focused.toolIds = new Set(annotationsToFocus.map(annotation => annotation.id));
            this.localState.focused.dentes = new Set(annotationsToFocus.map(annotation => annotation.localizacao.dentes.map(dente => dente.id)).flat());
            this.localState.focused.regioesAnatomicas = new Set(annotationsToFocus.map(annotation => annotation.localizacao.regioesAnatomicas.map(regiao => regiao.id)).flat());
            // this.localState.focused.toolIds.clear();
            // this.localState.focused.dentes.clear();
            // this.localState.focused.regioesAnatomicas.clear();
            // annotationsToFocus.forEach(annotation => {

            //     this.localState.focused.toolIds.add(annotation.id);
            //     annotation.localizacao.dentes.forEach(dente => {
            //         this.localState.focused.dentes.add(dente.id);
            //     });
            //     annotation.localizacao.regioesAnatomicas.forEach(regiao => {
            //         this.localState.focused.regioesAnatomicas.add(regiao.id);
            //     });
            // })
        });

        evtBus.$on('evt_annotationItem_blur', (payload) => {
            if (this.localState.focusLocation == gConsts.mov.focusLocations.POPUP_ANOTACAO)
                return;
            // console.log('evt_annotationItem_onBlur: ', payload);
            this.localState.focused.toolIds.clear();
            this.localState.focused.dentes.clear();
            this.localState.focused.regioesAnatomicas.clear();
        });

        this.registerSegmentationFixEventListeners();

        window['updateLocationCount'] = 0;
    },

    // -----------------------------------------------------------------

    mounted() {
        this.htmlElems = {
            parentElem: this.$el.parentNode,
            workAreaZoom: document.getElementById('div_workAreaZoom'),
            workArea: document.getElementById('div_workArea'),
            sidebarPanels: document.getElementById('div_sidebarPanels'),
            popupAnotacao: document.querySelector('div[data-compType="popupAnotacao"]'),
            sidePanels: Array.from(document.querySelectorAll("div[data-compType='sidePanels']")),
            sidePanelsItems: [],
            relatorio: document.getElementById('div_spRelatorio'),
            mainImg: document.getElementById('mainImg'),
            svgTools: document.getElementById('svg_tools'),
            nodeSearchInput: document.getElementById('nodeSearchInput')
        }

        document.documentElement.addEventListener('mousedown', this.mouseEvents);
        document.addEventListener('mousemove', _.throttle(this.mouseEvents, 40, { leading: true, trailing: false }));

        document.documentElement.addEventListener('mouseup', this.mouseEvents);
        document.documentElement.addEventListener('dblclick', this.mouseEvents);
        document.documentElement.addEventListener('keydown', this.keyboardEvents);
        document.documentElement.addEventListener('keyup', this.keyboardEvents);
        document.documentElement.addEventListener('wheel', this.zoom, { capture: false, passive: false });
        document.documentElement.addEventListener('fullscreenchange', this.onFullscreenChange);

        this.observeSidebarPanelResize();


        this.$updateActiveDenteOnStore = _.debounce(this.updateActiveDenteOnStore, 50);
        this.$updateJobToolsOnStore = _.debounce(this.updateJobToolsOnStore, 500);
        this.$updateWorkAreaZoomOnStore = _.debounce(this.updateWorkAreaZoomOnStore, 250);
        this.$updateToolVisibleLabel = _.debounce(this.updateToolVisibleLabel, 50);

        this.$updateActiveToothRegionLocations = _.debounce(this.updateActiveToothRegionLocations, 30);
    },

    // -----------------------------------------------------------------

    beforeDestroy() {
        document.documentElement.removeEventListener('mousedown', this.mouseEvents);
        document.documentElement.removeEventListener('mousemove', this.mouseEvents);
        document.documentElement.removeEventListener('mouseup', this.mouseEvents);
        document.documentElement.removeEventListener('dblclick', this.mouseEvents);
        document.documentElement.removeEventListener('keydown', this.keyboardEvents);
        document.documentElement.removeEventListener('keyup', this.keyboardEvents);
        document.documentElement.removeEventListener('wheel', this.zoom);
        document.documentElement.removeEventListener('fullscreenchange', this.onFullscreenChange);

        this.disconnectSidebarPanelResizeObserver();
    }
}
</script>

// =========================================================================================
// =========================================================================================

<style scoped>
#div_tools[data-clear-img-view="true"] :deep(.tool_container) {
    opacity: 0 !important;
}

#div_tools[data-tools-are-selectable="true"] :deep(.tool_container) {
    cursor: pointer;
}

#denticaoPreviewRect {
    fill: rgba(255, 0, 0, 0.2);
    stroke-width: calc(2 / var(--wa-zoom-scale));
    opacity: 0.3;
    stroke: #fff;
}

#toolPushCircle {
    stroke-width: calc(2 / var(--wa-zoom-scale));
    opacity: 0.3;
}

#g_internalLocationTools[data-show-face-tools="true"] :deep(.tool_container[data-label*='_faces_']),
#g_internalLocationTools[data-show-portion-tools="true"] :deep(.tool_container[data-label*='_porcoes_']),
#g_internalLocationTools[data-show-other-internal-tools="true"] :deep(.tool_container[data-label*='_others_']),
#g_probableToothTools[data-show-tools="true"] :deep(.tool_container[data-label*='lb_dente']) {
    opacity: 1 !important;
}

#path_segmentationFix,
#path_segmentationFixResult {
    fill: rgba(0, 255, 0, 0.1);
    stroke-width: calc(3 / var(--wa-zoom-scale, 1));
    opacity: 0.6;
    stroke: #fff;
}


#path_segmentationFix {
    pointer-events: fill;
}

#path_segmentationFixResult {
    fill-opacity: 0;
    stroke-dasharray: var(--path-length);
    stroke-dashoffset: var(--path-length);
    visibility: hidden;
}

#path_segmentationFixResult.drawing-path--single {
    visibility: visible;
}

.drawing-path--single {
    animation: drawLineFill 0.7s ease-out forwards;
}

#g_segmentationFix[data-loading="true"] #path_segmentationFix {
    stroke-dasharray: var(--path-length);
    stroke-dashoffset: var(--path-length);

    animation: drawLine 1.5s ease-in-out infinite;
}

@keyframes drawLineFill {
    0% {
        fill-opacity: 0;
    }

    95% {
        stroke-dashoffset: 0;
        fill-opacity: 0;
    }

    100% {
        fill-opacity: 1;
        stroke-dashoffset: 0;
    }
}

@keyframes drawLine {
    to {
        stroke-dashoffset: 0;
    }
}
</style>